<template>
  <div class="container">
    <div class="spot_pc">
      <carousel
        :dots="false"
        :autoplay="true"
        :nav="false"
        :items="1"
        class="spot_03"
      >
        <div class="item" id="item">
          <a class="ori">
            <div class="item_caption">
              <h1>
                CreateX는 새로운 시대 새로운 꿈 새로운 교육을 대표하는
                브랜드로,<br />
                성장기 학생들이 최고가 되는 경험을 통해 꿈을 실현하도록
                지원합니다.
              </h1>
            </div>
          </a>
        </div>
      </carousel>
    </div>
    <div class="mblock">
      <div class="mblock_style_01">
        <div class="width_wrap">
          <ul>
            <li>
              <router-link :to="`${USER_ROUTES.Product.Testing.Putt.Path}`">
                <span>경험을 진단하다!</span>
                <h1>진단검사</h1>
                <n-icon size="30"><ChevronForward /></n-icon>
              </router-link>
            </li>
            <li>
              <router-link :to="`${USER_ROUTES.Product.Coaching.Putt.Path}`">
                <span>나를 디자인하다!</span>
                <h1>학습진로 상담코칭</h1>
                <n-icon size="30"><ChevronForward /></n-icon>
              </router-link>
            </li>
            <li>
              <router-link :to="`${USER_ROUTES.Product.Activity.Talent.Path}`">
                <span>최고의 나를 경험하다!</span>
                <h1>Activity</h1>
                <n-icon size="30"><ChevronForward /></n-icon>
              </router-link>
            </li>
            <li>
              <router-link :to="`${USER_ROUTES.Product.Expert.Expert.Path}`">
                <span>미래를 디자인하다!</span>
                <h1>전문가 교육</h1>
                <n-icon size="30"><ChevronForward /></n-icon>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="mblock_style_02">
      <div class="width_wrap">
        <ul>
          <li v-if="!isLoggedIn">
            <div class="pm-login_b_login_b" style="position: relative">
              <form name="left_login_box" @submit.prevent="handleSubmit">
                <input type="hidden" name="re_url" value="" />
                <fieldset class="body">
                  <legend>로그인 폼</legend>
                  <!-- 로그인 타입 선택 라디오 버튼 -->
                  <div
                    class="login-type-selector"
                    style="
                      margin-bottom: 8px;
                      text-align: left;
                      padding-left: 5px;
                    "
                  >
                    <label style="margin-right: 10px; font-size: 0.85em">
                      <input
                        type="radio"
                        name="home_login_type_radio"
                        value="user"
                        v-model="loginType"
                        style="vertical-align: middle; margin-right: 3px"
                      />
                      개인
                    </label>
                    <label style="font-size: 0.85em">
                      <input
                        type="radio"
                        name="home_login_type_radio"
                        value="organization"
                        v-model="loginType"
                        style="vertical-align: middle; margin-right: 3px"
                      />
                      기관
                    </label>
                  </div>

                  <dl class="from">
                    <dt>
                      <!-- 기관 로그인 시 -->
                      <input
                        v-if="loginType === 'organization'"
                        type="text"
                        v-model="form.orgId"
                        placeholder="기관 아이디"
                        style="margin-bottom: 5px"
                      />
                      <input
                        type="text"
                        v-model="form.uid"
                        :placeholder="
                          loginType === 'organization'
                            ? '사용자 아이디'
                            : '아이디'
                        "
                      />
                      <input
                        type="password"
                        v-model="form.password"
                        placeholder="비밀번호"
                        :required="loginType === 'user'"
                      />
                    </dt>
                    <dd>
                      <n-button
                        type="submit"
                        :loading="loading"
                        attr-type="submit"
                        :style="{
                          width: '100%',
                          height: loginButtonHeight,
                          backgroundColor: '#c0c0c0',
                          color: 'white',
                          border: 'none',
                          fontWeight: 600,
                          fontSize: '14px',
                        }"
                      >
                        로그인
                      </n-button>
                    </dd>
                  </dl>
                  <div class="checks">
                    <label>
                      <input
                        type="checkbox"
                        name="id_save"
                        value="1"
                        v-model="form.idSave"
                      />
                      &nbsp;<span>아이디 저장</span>
                    </label>
                  </div>
                </fieldset>
              </form>

              <div v-if="loginType === 'organization'" class="nav">
                <router-link
                  :to="`${USER_ROUTES.RequestOrgRegist.Path}`"
                  style="width: 100%; margin-right: 0; font-size: 15px"
                >
                  [신규]기관등록신청
                </router-link>
              </div>
              <div v-else class="nav">
                <router-link :to="`${USER_ROUTES.Join.Path}`"
                  >회원가입</router-link
                >
                <a href="#" @click.prevent="openForgotPasswordModal"
                  >비밀번호찾기</a
                >
              </div>

              <!-- 소셜 로그인 버튼 영역 (일반 회원 로그인 시에만 표시) -->
              <template v-if="loginType === 'user'">
                <div
                  class="social-login-buttons"
                  style="
                    margin-top: 8px; /* 간격 조정 */
                    text-align: center;
                    padding-top: 8px; /* 간격 조정 */
                    border-top: 1px solid #eee;
                  "
                >
                  <n-button
                    type="button"
                    @click="signInWithGoogle"
                    style="
                      background-color: #db4437;
                      color: white;
                      border: none;
                      border-radius: 4px;
                      cursor: pointer;
                      margin-right: 10px;
                      font-size: 0.85em;
                      padding: 8px 12px; /* 패딩 유지 */
                    "
                  >
                    구글 로그인
                  </n-button>
                  <n-button
                    type="button"
                    @click="signInWithKakao"
                    style="
                      background-color: #fee500;
                      color: #3c1e1e;
                      border: none;
                      border-radius: 4px;
                      cursor: pointer;
                      font-size: 0.85em;
                      padding: 8px 12px; /* 패딩 유지 */
                    "
                  >
                    카카오 로그인
                  </n-button>
                </div>
              </template>
              <SubLoading v-if="loading" />
            </div>
          </li>
          <!-- 로그인 시 -->
          <li v-else>
            <div class="pm-login_b_login_b">
              <div class="body">
                <p class="msg">
                  <strong>{{ loggedInUserId }}</strong
                  >님 반갑습니다.
                </p>
              </div>
              <div class="nav">
                <router-link
                  v-if="isOrgUser || isOrgAdmin"
                  :to="`${USER_ROUTES.Mypage.Order.Org.Path}`"
                  >마이페이지</router-link
                >
                <router-link
                  v-else
                  :to="`${USER_ROUTES.Mypage.Order.Personal.Path}`"
                  >마이페이지</router-link
                >
                <a href="#" @click.prevent="handleLogout">로그아웃</a>
              </div>
            </div>
          </li>

          <li class="box2">
            <router-link
              :to="`${USER_ROUTES.Price.Personal.Path}`"
              class="btn4"
            >
              <dl>
                <dt>개인</dt>
                <dd>예약 및 신청하기</dd>
              </dl>
              <n-icon size="25" class="arrow-icon"><ChevronForward /></n-icon>
            </router-link>

            <router-link
              :to="`${USER_ROUTES.Instruction.individual.Path}`"
              class="btn2"
            >
              <dl>
                <dt>이용 안내</dt>
                <dd></dd>
              </dl>
              <n-icon color="#BE7A42" size="25" class="arrow-icon"
                ><ChevronForward
              /></n-icon>
            </router-link>

            <router-link :to="`${USER_ROUTES.Inquiry.Path}`" class="btn2"
              ><dl>
                <dt>문의 하기</dt>
                <dd></dd>
              </dl>
              <n-icon color="#BE7A42" size="25" class="arrow-icon"
                ><ChevronForward
              /></n-icon>
            </router-link>
          </li>
          <li class="box2">
            <router-link :to="`${USER_ROUTES.Price.Org.Path}`" class="btn1">
              <dl>
                <dt>기관</dt>
                <dd>예약 및 신청하기</dd>
              </dl>
              <n-icon size="25" class="arrow-icon"><ChevronForward /></n-icon>
            </router-link>
            <router-link :to="{}" @click="moveMyPage" class="btn5">
              <dl>
                <dt>개인·기관</dt>
                <dd>검사 실시하기</dd>
              </dl>
              <n-icon size="25" class="arrow-icon"><ChevronForward /></n-icon>
            </router-link>
            <router-link :to="{}" @click="moveMyPage" class="btn3">
              <dl>
                <dt>개인·기관</dt>
                <dd>결과리포트 열람하기</dd>
              </dl>
              <n-icon size="25" class="arrow-icon"><ChevronForward /></n-icon>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <!-- 비밀번호 찾기 모달 (Login.vue와 동일한 구조) -->
    <n-modal
      v-model:show="showForgotPasswordModal"
      preset="card"
      style="width: 500px"
      title="비밀번호 찾기/재설정"
      :mask-closable="false"
      :closable="true"
      @after-leave="forgotPasswordUid = ''"
    >
      <p style="margin-bottom: 15px">
        아이디를 입력해주세요. 가입 시 등록된 이메일 주소로 임시 비밀번호가
        전송됩니다. 로그인 후 반드시 비밀번호를 변경해주세요.
      </p>
      <n-form @submit.prevent="handleForgotPasswordRequest">
        <n-form-item label="아이디" path="forgotPasswordUid">
          <n-input
            v-model:value="forgotPasswordUid"
            placeholder="아이디 입력"
            @keydown.enter.prevent="handleForgotPasswordRequest"
          />
        </n-form-item>
        <n-space justify="end">
          <n-button
            @click="closeForgotPasswordModal"
            :disabled="forgotPasswordLoading"
            >취소</n-button
          >
          <n-button
            type="primary"
            attr-type="submit"
            :loading="forgotPasswordLoading"
          >
            임시 비밀번호 발송
          </n-button>
        </n-space>
      </n-form>
    </n-modal>

    <div class="mblock_style_03">
      <div class="width_wrap">
        <ul>
          <li>
            <h1>
              공지사항
              <router-link :to="`${USER_ROUTES.Notice.Path}`"
                >더보기 +</router-link
              >
            </h1>
            <div class="bbs_wrap">
              <div class="pm-board_list_mnotice">
                <ul v-if="isNoticeListLoading">
                  <li>
                    <p
                      class="empty"
                      style="text-align: center; padding: 10px 0"
                    >
                      공지사항 조회 중...
                    </p>
                  </li>
                </ul>
                <ul v-else-if="noticeList.length > 0">
                  <li v-for="notice in noticeList.slice(0, 4)" :key="notice.SK">
                    <!-- 최근 4개만 표시 -->
                    <router-link
                      :to="{
                        name: USER_ROUTES.Notice.Content.Name,
                        params: { id: notice.SK },
                      }"
                    >
                      <dl>
                        <dt>{{ notice.title }}</dt>
                        <dd>{{ common.getYYYYMMDD2(notice.createdDate) }}</dd>
                      </dl>
                    </router-link>
                  </li>
                </ul>
                <ul v-else>
                  <li>
                    <p
                      class="empty"
                      style="text-align: center; padding: 10px 0"
                    >
                      공지사항이 없습니다.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </li>

          <li>
            <h1>
              홍보/자료실
              <router-link :to="`${USER_ROUTES.Press.Path}`"
                >더보기 +</router-link
              >
            </h1>
            <div class="bbs_wrap">
              <div class="pm-board_list_mboard">
                <ul v-if="isPressListLoading">
                  <li>
                    <p
                      class="empty"
                      style="text-align: center; padding: 10px 0"
                    >
                      홍보자료 조회 중...
                    </p>
                  </li>
                </ul>
                <ul v-else-if="pressList.length > 0">
                  <li v-for="press in pressList.slice(0, 4)" :key="press.SK">
                    <!-- 최근 4개만 표시 -->
                    <router-link
                      :to="{
                        name: USER_ROUTES.Press.Content.Name,
                        params: { id: press.SK },
                      }"
                    >
                      <dl>
                        <dt>{{ press.title }}</dt>
                        <dd>{{ common.getYYYYMMDD2(press.createdDate) }}</dd>
                      </dl>
                    </router-link>
                  </li>
                </ul>
                <ul v-else>
                  <li>
                    <p
                      class="empty"
                      style="text-align: center; padding: 10px 0"
                    >
                      홍보자료가 없습니다.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <li>
            <h1>
              FAQ
              <router-link :to="`${USER_ROUTES.Qna.Path}`"
                >더보기 +</router-link
              >
            </h1>
            <div class="bbs_wrap">
              <div class="pm-board_list_mfaq">
                <ul v-if="isQnaListLoading">
                  <li>
                    <p
                      class="empty"
                      style="text-align: center; padding: 10px 0"
                    >
                      FAQ 조회 중...
                    </p>
                  </li>
                </ul>
                <ul v-else-if="qnaList.length > 0">
                  <li v-for="qna in qnaList.slice(0, 4)" :key="qna.SK">
                    <!-- 최근 4개만 표시 -->
                    <router-link
                      :to="{
                        name: USER_ROUTES.Qna.Content.Name,
                        params: { id: qna.SK },
                      }"
                    >
                      <dl>
                        <dt>{{ qna.question }}</dt>
                        <dd>{{ common.getYYYYMMDD2(qna.createdDate) }}</dd>
                      </dl>
                    </router-link>
                  </li>
                </ul>
                <ul v-else>
                  <li>
                    <p
                      class="empty"
                      style="text-align: center; padding: 10px 0"
                    >
                      FAQ가 없습니다.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="mblock_05">
      <div class="mblock_06" style="padding: 50px 10px">
        <h1>PUTT2.0 다중재능검사</h1>

        <div class="wrap_flex" style="padding-top: 15px">
          <div style="width: 100%; max-width: 1300px">
            <div
              class="card-header"
              style="text-align: center; margin-bottom: 15px; font-size: 16px"
            >
              <span
                >PUTT2.0 다중재능검사는 개인의 타고난 재능과 경험을 측정하는
                검사로,<br />
                개인이 자아 발견을 통해 꿈을 찾고 미래를 예측, 설계하여 자아
                실현하도록 하는 데 목적이 있습니다.<br />
                PUTT2.0 다중재능검사는 재능의 발달단계에 따라 초등학생용, 중학생용,
                고등학생용, 대학생용으로 구분, 실시합니다</span
              >
            </div>
            <div class="wrap_flex">
              <div class="card" @click="goToPuttE" style="max-width: 300px">
                <div class="card-body">
                  <img src="@/assets/img/testing/putt_e_2_0_s.png" />
                </div>
              </div>
              <div class="card" @click="goToPuttM" style="max-width: 300px">
                <div class="card-body">
                  <img src="@/assets/img/testing/putt_m_2_0_s.png" />
                </div>
              </div>
              <div class="card" @click="goToPuttH" style="max-width: 300px">
                <div class="card-body">
                  <img src="@/assets/img/testing/putt_h_2_0_s.png" />
                </div>
              </div>
              <div class="card" @click="goToPuttU" style="max-width: 300px">
                <div class="card-body">
                  <img src="@/assets/img/testing/putt_u_2_0_s.png" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mblock_06" style="padding: 50px 10px">
        <h1>TOCC·TEC 창의역량검사</h1>

        <div class="wrap_flex" style="padding-top: 15px">
          <div style="width: 100%; max-width: 1300px">
            <div
              class="card-header"
              style="text-align: center; margin-bottom: 15px; font-size: 16px"
            >
              <span
                >TOCC(TEC)창의역량검사는 ‘모든 사람의 창의역량’을 총체적,
                다원적으로 측정하는 검사로,<br />
                개인의 특별한 경험을 발굴, 확장, 극대화함으로써 행복한 현재 삶은
                물론 미래 기회를 창조하도록 지원하는 데 목적이 있습니다.<br />
                TOCC창의역량검사는 창의역량의 발달단계에 따라 아동용,
                청소년용으로, TEC_전문가용으로 구분, 실시합니다.</span
              >
            </div>
            <div class="wrap_flex">
              <div class="card" @click="goToToccC" style="max-width: 300px">
                <div class="card-body">
                  <img src="@/assets/img/testing/tocc_e_s.png" />
                </div>
              </div>
              <div class="card" @click="goToToccY" style="max-width: 300px">
                <div class="card-body">
                  <img src="@/assets/img/testing/tocc_h_s.png" />
                </div>
              </div>
              <div class="card" @click="goToTecP" style="max-width: 300px">
                <div class="card-body">
                  <img src="@/assets/img/testing/tec_s.png" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mblock_06">
        <h1>PUTT2.0 · TOCC · TEC<br />검사 및 상담코칭 이용 안내</h1>
        <div class="wrap_flex" style="padding-top: 15px">
          <div style="width: 100%; max-width: 450px">
            <div
              class="card-header"
              style="text-align: center; margin-bottom: 15px"
            >
              <h2>개인</h2>
              <p>
                ※ 전문 학습진로 상담코칭 지원 대상, 피검자 1인 또는 소수 개인
              </p>
            </div>
            <div class="card card-borad" @click="goToIndividualInstruction">
              <div class="card-body" style="height: 130px">
                <h3>온라인 검사 실시 안내</h3>
                <img
                  src="@/assets/img/individual_manual.png"
                  alt="개인 아이콘"
                  class="icon2"
                />
                <p>
                  검사 실시 준비 &gt;&gt; 검사 실시 &gt;&gt; 결과 확인·<span
                    class="highlight"
                    >상담코칭</span
                  >
                </p>
              </div>
            </div>
          </div>
          <div style="width: 100%; max-width: 450px">
            <div
              class="card-header"
              style="text-align: center; margin-bottom: 15px"
            >
              <h2>기관</h2>
              <p>
                ※ 전문 학습진로상담코칭 자체 지원 가능 기관, 피검사자 16인
                이상의 단체, 기관
              </p>
            </div>
            <div class="card card-borad" @click="goToOrgInstruction">
              <div class="card-body" style="height: 130px">
                <h3 style="margin-bottom: 20px">온라인 검사 실시 안내</h3>
                <img
                  style="height: 43px !important; width: 45px !important"
                  src="@/assets/img/org_manual.png"
                  alt="기관 아이콘"
                  class="icon2"
                />
                <p style="margin-top: 3px">
                  검사 실시 준비 &gt;&gt; 검사 실시 &gt;&gt; 결과 확인·<span
                    class="highlight"
                    >상담코칭</span
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mblock_06" style="padding: 50px 10px">
        <h1>학습진로 상담코칭</h1>

        <div class="wrap_flex" style="padding-top: 15px">
          <div style="width: 100%; max-width: 1300px">
            <div
              class="card-header"
              style="text-align: center; margin-bottom: 15px; font-size: 16px"
            >
              <span
                >PUTT2.0 및 TOCC(TEC) 결과를 바탕으로,<br />
                학생의 학업 문제를 정의, 해결하고 신체적 및 지적 성장 발달과
                세상의 변화에 대처하기 위한 전략을 제시하는 데 목적이
                있습니다.<br />
                PUTT은 개인 재능의 최적화를, TOCC*TEC은 개인 재능의 극대화를
                목표로 합니다.</span
              >
            </div>
            <div class="wrap_flex">
              <div class="card" @click="goToPuttCE" style="max-width: 300px">
                <div class="card-body">
                  <img src="@/assets/img/testing/putt_e_2_0_coaching.png" />
                </div>
              </div>
              <div class="card" @click="goToPuttCM" style="max-width: 300px">
                <div class="card-body">
                  <img src="@/assets/img/testing/putt_m_2_0_coaching.png" />
                </div>
              </div>
              <div class="card" @click="goToPuttCH" style="max-width: 300px">
                <div class="card-body">
                  <img src="@/assets/img/testing/putt_h_2_0_coaching.png" />
                </div>
              </div>
              <div class="card" @click="goToPuttCU" style="max-width: 300px">
                <div class="card-body">
                  <img src="@/assets/img/testing/putt_u_2_0_coaching.png" />
                </div>
              </div>
            </div>
            <div class="wrap_flex" style="padding-top: 20px">
              <div class="card" @click="goToToccCE" style="max-width: 300px">
                <div class="card-body">
                  <img src="@/assets/img/testing/tocc_e_coaching.png" />
                </div>
              </div>
              <div class="card" @click="goToToccCM" style="max-width: 300px">
                <div class="card-body">
                  <img src="@/assets/img/testing/tocc_m_coaching.png" />
                </div>
              </div>
              <div class="card" @click="goToToccCH" style="max-width: 300px">
                <div class="card-body">
                  <img src="@/assets/img/testing/tocc_h_coaching.png" />
                </div>
              </div>
              <div class="card" @click="goToToccCU" style="max-width: 300px">
                <div class="card-body">
                  <img src="@/assets/img/testing/tec_coaching.png" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mblock_06" style="padding: 50px 10px">
        <h1>재능탐색 · 진로탐색 · 전공탐색 · 직업탐색 프로젝트</h1>

        <div class="wrap_flex" style="padding-top: 15px">
          <div style="width: 100%; max-width: 1300px">
            <div
              class="card-header"
              style="text-align: center; margin-bottom: 15px; font-size: 16px"
            >
              <span
                >PUTT2.0 기반 재능진로전공직업 탐색 프로젝트는 성장기 학생들의 발달
                특성을 고려하여 <br />내적 성장으로 인한 현재의 변화무쌍한 관심,
                재능, 과업에 직면하도록 하여 도전, 성취를 경험하도록 하는
                과정입니다.</span
              >
            </div>
            <div class="wrap_flex">
              <div class="card" @click="goToTalentCE" style="max-width: 300px">
                <div class="card-body">
                  <h3>어린이 놀이공원 건립</h3>
                  <br /><br />

                  <img src="@/assets/img/talent_e.png" class="icon" />
                  <br /><br />
                  <p>Activity_재능탐색_초등학생</p>
                </div>
              </div>
              <div class="card" @click="goToTalentCM" style="max-width: 300px">
                <div class="card-body">
                  <h3>청소년문화공간 건립</h3>
                  <br /><br />

                  <img src="@/assets/img/talent_m.png" class="icon" />
                  <br /><br />
                  <p>Activity_진로탐색_중학생</p>
                </div>
              </div>
              <div class="card" @click="goToTalentCH" style="max-width: 300px">
                <div class="card-body">
                  <h3>미래 도시 건립</h3>
                  <br /><br />
                  <img src="@/assets/img/talent_h.png" class="icon" />
                  <br /><br />
                  <p>Activity_전공탐색_고등학생</p>
                </div>
              </div>
              <div class="card" @click="goToTalentCU" style="max-width: 300px">
                <div class="card-body">
                  <h3>미래 작업공간 건립</h3>
                  <br /><br />
                  <img src="@/assets/img/talent_u.png" class="icon" />
                  <br /><br />
                  <p>Activity_직업탐색_대학생</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mblock_06" style="padding: 50px 10px">
        <h1>꿈 · 창업 프로젝트</h1>

        <div class="wrap_flex" style="padding-top: 15px">
          <div style="width: 100%; max-width: 1300px">
            <div
              class="card-header"
              style="text-align: center; margin-bottom: 15px; font-size: 16px"
            >
              <span
                >꿈·창업 프로젝트는 꿈을 실현하는 경험을 지원하는데 목표를
                둡니다.<br />
                꿈 · 창업 프로젝트는 학생이 자아 발견 과정을 통해 꿈을 명확하게
                하여 그 꿈을 실현할 가상의 세상을 만드는 과정입니다.</span
              >
            </div>
            <div class="wrap_flex">
              <div class="card" @click="goToStartUpCE" style="max-width: 300px">
                <div class="card-body">
                  <h3>재능발견으로 꿈·창업</h3>
                  <br /><br />

                  <img src="@/assets/img/startup_e.png" class="icon" />
                  <br /><br />
                  <p>Activity_꿈·창업_초등학생</p>
                </div>
              </div>
              <div class="card" @click="goToStartUpCM" style="max-width: 300px">
                <div class="card-body">
                  <h3>재능발휘로 꿈·창업</h3>
                  <br /><br />

                  <img src="@/assets/img/startup_m.png" class="icon" />
                  <br /><br />
                  <p>Activity_ 꿈·창업_중학생</p>
                </div>
              </div>
              <div class="card" @click="goToStartUpCH" style="max-width: 300px">
                <div class="card-body">
                  <h3>재능디자인으로 꿈·창업</h3>
                  <br /><br />
                  <img src="@/assets/img/startup_h.png" class="icon" />
                  <br /><br />
                  <p>Activity_꿈·창업_ 고등학생</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mblock_06" style="padding: 50px 10px">
        <h1>데이터 사이언스 체험 활동</h1>

        <div class="wrap_flex" style="padding-top: 15px">
          <div style="width: 100%; max-width: 1300px">
            <div
              class="card-header"
              style="text-align: center; margin-bottom: 15px; font-size: 16px"
            >
              <span
                >데이터 사이언스 체험 활동은 재능검사 개발 및 분석 활동을 통해
                자신의 재능을 이해, 진로 탐색함은 물론<br />인간행동을 측정,
                분석, 예측함으로써 미래 문제를 데이터 기반 의사결정 하는 과정을
                수행한다.
              </span>
            </div>
            <div class="wrap_flex">
              <div class="card" @click="goToCareerE" style="max-width: 300px">
                <div class="card-body">
                  <h3>인간행동 측정 및 예측</h3>
                  <br /><br />

                  <img src="@/assets/img/career_e.png" class="icon" />
                  <br /><br />
                  <p>Activity_데이터사이언스_초등학생</p>
                </div>
              </div>
              <div class="card" @click="goToCareerM" style="max-width: 300px">
                <div class="card-body">
                  <h3>인간행동 측정 및 예측</h3>
                  <br /><br />

                  <img src="@/assets/img/career_m.png" class="icon" />
                  <br /><br />
                  <p>Activity_데이터사이언스_중학생</p>
                </div>
              </div>
              <div class="card" @click="goToCareerH" style="max-width: 300px">
                <div class="card-body">
                  <h3>인간행동 측정 및 예측</h3>
                  <br /><br />
                  <img src="@/assets/img/career_h.png" class="icon" />
                  <br /><br />
                  <p>Activity_데이터사이언스_고등학생</p>
                </div>
              </div>
              <div class="card" @click="goToCareerU" style="max-width: 300px">
                <div class="card-body">
                  <h3>인간행동 측정 및 예측</h3>
                  <br /><br />
                  <img src="@/assets/img/career_u.png" class="icon" />
                  <br /><br />
                  <p>Activity_데이터사이언스_대학생</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mblock_06" style="padding: 50px 10px">
        <h1>성장-폴리오 프로젝트</h1>

        <div class="wrap_flex" style="padding-top: 15px">
          <div style="width: 100%; max-width: 1300px">
            <div
              class="card-header"
              style="text-align: center; margin-bottom: 15px; font-size: 16px"
            >
              <span
                >PUTT2.0 기반 성장-폴리오 프로젝트는 학생이 자신의 크고 작은 경험을
                발굴, 재해석하는 과정으로 이루어집니다.<br />
                이 과정을 통해 학생은 자신의 경험을 새롭게 mapping, 디자인하는
                과제를 수행합니다.
              </span>
            </div>
            <div class="wrap_flex">
              <div class="card" @click="goToGrowthM" style="max-width: 300px">
                <div class="card-body">
                  <h3>경험 - 자랑스런 나</h3>
                  <br /><br />

                  <img src="@/assets/img/growth_m.png" class="icon" />
                  <br /><br />
                  <p>Activity_성장폴리오_중학생</p>
                </div>
              </div>
              <div class="card" @click="goToGrowthH" style="max-width: 300px">
                <div class="card-body">
                  <h3>경험 - 특별한 나</h3>
                  <br /><br />

                  <img src="@/assets/img/growth_h.png" class="icon" />
                  <br /><br />
                  <p>Activity_성장폴리오_고등학생</p>
                </div>
              </div>
              <div class="card" @click="goToGrowthU" style="max-width: 300px">
                <div class="card-body">
                  <h3>경험 - 최고의 나</h3>
                  <br /><br />
                  <img src="@/assets/img/growth_u.png" class="icon" />
                  <br /><br />
                  <p>Activity_성장폴리오_대학생</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mblock_06" style="padding: 50px 10px">
        <h1>전문가 과정</h1>

        <div class="wrap_flex" style="padding-top: 15px">
          <div style="width: 100%; max-width: 1300px">
            <div
              class="card-header"
              style="text-align: center; margin-bottom: 15px; font-size: 16px"
            >
              <span
                >다중재능코칭 전문가 과정은 PUTT2.0 이해를 기반으로 결과 분석 및
                해석, 상담코칭, 전문가 강의 등을 수행할 수 있는 역량 계발
                과정입니다.<br />
                다중재능코칭 전문가 교육은 초급과정, 고급과정, 최고과정으로
                구성됩니다.</span
              >
            </div>
            <div class="wrap_flex">
              <div class="card" @click="goToExpertE" style="max-width: 300px">
                <div class="card-body">
                  <h3>검사 이해·결과 분석</h3>
                  <br /><br />

                  <img src="@/assets/img/expert_e.png" class="icon" />
                  <br /><br />
                  <p>다중재능코칭_전문가_초급과정</p>
                </div>
              </div>
              <div class="card" @click="goToExpertH" style="max-width: 300px">
                <div class="card-body">
                  <h3>철학·개념모델 이해</h3>
                  <br /><br />

                  <img src="@/assets/img/expert_h.png" class="icon" />
                  <br /><br />
                  <p>다중재능코칭_전문가_고급과정</p>
                </div>
              </div>
              <div class="card" @click="goToExpertB" style="max-width: 300px">
                <div class="card-body">
                  <h3>교수설계·강의역량 강화</h3>
                  <br /><br />
                  <img src="@/assets/img/expert_b.png" class="icon" />
                  <br /><br />
                  <p>다중재능코칭_전문가_최고과정</p>
                </div>
              </div>
              <div class="card" @click="goToExpertP" style="max-width: 300px">
                <div class="card-body">
                  <h3>경험 – 미래 창조</h3>
                  <br /><br />
                  <img src="@/assets/img/expert_p.png" class="icon" />
                  <br /><br />
                  <p>교육_성장폴리오_전문가 과정</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mblock_06">
        <h1>다중재능코칭 전문가 자격증 배지</h1>

        <div class="wrap_flex" style="padding-top: 15px">
          <div style="width: 100%; max-width: 700px">
            <div
              class="card-header"
              style="text-align: center; margin-bottom: 15px; font-size: 16px"
            >
              <span
                >다중재능코칭 전문가 교육-고급과정 이수자에게는 다중재능코칭
                전문가 2급 자격증을,<br />
                다중재능코칭 전문가 교육- 최고과정 이수자에게는 다중재능코칭
                전문가 1급 자격증을 부여합니다.</span
              >
            </div>
            <div class="card" style="cursor: default; max-width: 700px">
              <div class="card-body">
                <h3>다중재능상담코칭 전문가 자격 관리</h3>
                <br />
                <img src="@/assets/img/pro.png" class="icon" />
                <br />
                <p>초급과정 · 고급과정 · 최고과정</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <carousel
      :dots="false"
      :autoplay="true"
      :nav="false"
      :responsive="{ 0: { items: 1 }, 768: { items: 4 } }"
      id="owl_partner"
      class="carousel pm-banner_slide_responsive_partner"
    >
      <div class="item">
        <a href="https://www.ggoomgil.go.kr/front/index.do" target="_blank">
          <img
            src="@/assets/thum_img/kp708b/banner/82bd168d504ed8ad7ee5e1a716a33aba_water__c1_w278_h70.jpg"
            alt="꿈길"
          />
        </a>
      </div>
      <div class="item">
        <a href="https://jinroad.or.kr/" target="_blank">
          <img
            src="@/assets/thum_img/kp708b/banner/87f8408df5f1dc10fa8bcf82d8ff0db2_water__c1_w278_h70.jpg"
            alt="진로路"
          />
        </a>
      </div>
      <div class="item">
        <a href="https://www.pqi.or.kr/indexMain.do" target="_blank">
          <img
            src="@/assets/thum_img/kp708b/banner/bce288d618734adf7ec12768fd2b4455_water__c1_w278_h70.png"
            alt="PQI"
          />
        </a>
      </div>
      <div class="item">
        <a href="https://www.moe.go.kr/main.do?s=moe" target="_blank">
          <img
            src="@/assets/thum_img/kp708b/banner/ca7d5532cc9f31e9233e393ac61617f2_water__c1_w278_h70.png"
            alt="교육부"
          />
        </a>
      </div>
    </carousel>
    <div
      id="owl_partner"
      class="owl-carousel pm-banner_slide_responsive_partner"
    >
      <div class="item">
        <a href="https://www.ggoomgil.go.kr/front/index.do" target="_blank">
          <img
            src="@/assets/thum_img/kp708b/banner/82bd168d504ed8ad7ee5e1a716a33aba_water__c1_w278_h70.jpg"
            alt="꿈길"
          />
        </a>
      </div>
      <div class="item">
        <a href="https://jinroad.or.kr/" target="_blank">
          <img
            src="@/assets/thum_img/kp708b/banner/87f8408df5f1dc10fa8bcf82d8ff0db2_water__c1_w278_h70.jpg"
            alt="진로路"
          />
        </a>
      </div>
      <div class="item">
        <a href="https://www.pqi.or.kr/indexMain.do" target="_blank">
          <img
            src="@/assets/thum_img/kp708b/banner/bce288d618734adf7ec12768fd2b4455_water__c1_w278_h70.png"
            alt="PQI"
          />
        </a>
      </div>
      <div class="item">
        <a href="https://www.moe.go.kr/main.do?s=moe" target="_blank">
          <img
            src="@/assets/thum_img/kp708b/banner/ca7d5532cc9f31e9233e393ac61617f2_water__c1_w278_h70.png"
            alt="교육부"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import P_PUTT_Items from "@/views/product/testing/PUTT_Items.vue";
import P_TOCC_Items from "@/views/product/testing/TOCC_Items.vue";
import C_PUTT_Items from "@/views/product/coaching/PUTT_Items.vue";
import C_TOCC_Items from "@/views/product/coaching/TOCC_Items.vue";
import Talent_Items from "@/views/product/activity/Talent_Items.vue";
import Career_Items from "@/views/product/activity/Career_Items.vue";
import Growth_Items from "@/views/product/activity/Growth_Items.vue";
import Startup_Items from "@/views/product/activity/Startup_Items.vue";
import Expert_Items from "@/views/product/expert/Expert_Items.vue";
import Certification_Items from "@/views/product/expert/Certification_Items.vue";

import { NIcon } from "naive-ui";
import { ChevronForward } from "@vicons/ionicons5";
import { LocationSharp } from "@vicons/ionicons5";
import carousel from "vue-owl-carousel/src/Carousel";
import Banner from "@/components/Banner.vue";
import Loading from "@/components/Loading.vue";
import SubLoading from "@/components/SubLoading.vue";
import { USER_ROUTES } from "@/assets/route_constants";
import { useAuth } from "@/composables/useAuth";
import { firebaseAuth, getCallable, makeCallApiParam } from "@/config/env";
import { Notice } from "@/model/notice";
import { Qna } from "@/model/qna";
import { ref, onMounted, watch, computed } from "vue";
import { Press } from "@/model/press";
import * as common from "@/assets/common/common";
import * as constant from "@/constants/constant";
import { useRouter } from "vue-router";
import { useAlertDialog } from "@/composables/useAlert";
const useAlert = useAlertDialog();
const router = useRouter();

const {
  loginType,
  form,
  loading,
  isLoggedIn,
  loggedInUserId,
  isOrgUser,
  isOrgAdmin,
  signInWithGoogle,
  signInWithKakao,
  showForgotPasswordModal,
  forgotPasswordUid,
  forgotPasswordLoading,
  openForgotPasswordModal,
  closeForgotPasswordModal,
  handleForgotPasswordRequest,
  handleSubmit,
  handleLogout,
} = useAuth();

watch(loginType, (newLoginType, oldLoginType) => {
  if (newLoginType !== oldLoginType) {
    form.value.orgId = "";
    form.value.uid = "";
    form.value.password = "";
    // 필요하다면 '아이디 저장' 등의 체크박스 상태도 초기화할 수 있습니다.
  }
});

const loginButtonHeight = computed(() => {
  if (loginType.value === "organization") {
    // 기관 아이디 (35px) + margin-bottom (5px) + 사용자 아이디 (35px) + margin-top (8px) + 비밀번호 (35px)
    return "118px"; // 35 + 5 + 35 + 8 + 35 = 118px
  } else {
    // 아이디 (35px) + margin-top (8px) + 비밀번호 (35px)
    return "78px"; // 35 + 8 + 35 = 78px
  }
});

const getCallApiCallable = getCallable("callApi");
const getBoards = "getBoards";

const noticeList = ref<Notice[]>([]);
const qnaList = ref<Qna[]>([]);
const pressList = ref<Press[]>([]);
const isNoticeListLoading = ref(false);
const isPressListLoading = ref(false);
const isQnaListLoading = ref(false);

async function showAlertAndNavigate() {
  await useAlert("준비 중 입니다.");
}

async function moveMyPage() {
  if (!isLoggedIn.value) {
    await useAlert("회원전용 페이지 입니다. 로그인 후 이용해주세요.");
    return;
  }
  if (isOrgUser.value || isOrgAdmin.value) {
    router.push(USER_ROUTES.Mypage.Order.Org.Path);
  } else {
    router.push(USER_ROUTES.Mypage.Order.Personal.Path);
  }
}

async function getNoticeList() {
  common.asyncFunction(async () => {
    isNoticeListLoading.value = true;
    const result: any = await getCallApiCallable(
      makeCallApiParam(getBoards, {
        type: constant.boardType.NOTICE,
      })
    );
    if (common.evalFunctionResult(result)) {
      noticeList.value = common.getItemListFromFunctionResult(result);
    } else {
      console.error("Failed to load notices:", common.getResultError(result));
    }
    isNoticeListLoading.value = false;
  });
}

async function getQnaList() {
  common.asyncFunction(async () => {
    isQnaListLoading.value = true;
    const result: any = await getCallApiCallable(
      makeCallApiParam(getBoards, { type: constant.boardType.QNA })
    );
    if (common.evalFunctionResult(result)) {
      qnaList.value = common.getItemListFromFunctionResult(result);
    } else {
      console.error("Failed to load qnaList:", common.getResultError(result));
    }
    isQnaListLoading.value = false;
  });
}

async function getPressList() {
  common.asyncFunction(async () => {
    isPressListLoading.value = true;
    const result: any = await getCallApiCallable(
      makeCallApiParam(getBoards, {
        type: constant.boardType.PRESS,
      })
    );
    if (common.evalFunctionResult(result)) {
      pressList.value = common.getItemListFromFunctionResult(result);
    } else {
      console.error("Failed to load qnaList:", common.getResultError(result));
    }
    isPressListLoading.value = false;
  });
}

onMounted(() => {
  getNoticeList(); // 컴포넌트 마운트 시 공지사항 목록 가져오기
  getQnaList(); // 컴포넌트 마운트 시 FAQ 목록 가져오기
  getPressList(); // 컴포넌트 마운트 시 홍보/자료실 목록 가져오기
});

function goToExpertE() {
  router.push(USER_ROUTES.Product.Expert.Expert.Expert_e.Path);
}
function goToExpertH() {
  router.push(USER_ROUTES.Product.Expert.Expert.Expert_h.Path);
}
function goToExpertB() {
  router.push(USER_ROUTES.Product.Expert.Expert.Expert_b.Path);
}
function goToExpertP() {
  router.push(USER_ROUTES.Product.Expert.Expert.Expert_p.Path);
}

function goToGrowthM() {
  router.push(USER_ROUTES.Product.Activity.Growth.Growth_e.Path);
}
function goToGrowthH() {
  router.push(USER_ROUTES.Product.Activity.Growth.Growth_m.Path);
}
function goToGrowthU() {
  router.push(USER_ROUTES.Product.Activity.Growth.Growth_h.Path);
}

function goToCareerE() {
  router.push(USER_ROUTES.Product.Activity.Career.Career_e.Path);
}
function goToCareerM() {
  router.push(USER_ROUTES.Product.Activity.Career.Career_m.Path);
}
function goToCareerH() {
  router.push(USER_ROUTES.Product.Activity.Career.Career_h.Path);
}
function goToCareerU() {
  router.push(USER_ROUTES.Product.Activity.Career.Career_u.Path);
}

function goToStartUpCE() {
  router.push(USER_ROUTES.Product.Activity.Startup.Startup_e.Path);
}
function goToStartUpCM() {
  router.push(USER_ROUTES.Product.Activity.Startup.Startup_m.Path);
}
function goToStartUpCH() {
  router.push(USER_ROUTES.Product.Activity.Startup.Startup_h.Path);
}

function goToTalentCE() {
  router.push(USER_ROUTES.Product.Activity.Talent.Talent_e.Path);
}
function goToTalentCM() {
  router.push(USER_ROUTES.Product.Activity.Talent.Talent_m.Path);
}
function goToTalentCH() {
  router.push(USER_ROUTES.Product.Activity.Talent.Talent_h.Path);
}
function goToTalentCU() {
  router.push(USER_ROUTES.Product.Activity.Talent.Talent_u.Path);
}

function goToToccCE() {
  router.push(USER_ROUTES.Product.Coaching.Tocc.Tocc_e.Path);
}
function goToToccCM() {
  router.push(USER_ROUTES.Product.Coaching.Tocc.Tocc_m.Path);
}
function goToToccCH() {
  router.push(USER_ROUTES.Product.Coaching.Tocc.Tocc_h.Path);
}
function goToToccCU() {
  router.push(USER_ROUTES.Product.Coaching.Tocc.Tec.Path);
}

function goToPuttCE() {
  router.push(USER_ROUTES.Product.Coaching.Putt.Putt_e.Path);
}
function goToPuttCM() {
  router.push(USER_ROUTES.Product.Coaching.Putt.Putt_m.Path);
}
function goToPuttCH() {
  router.push(USER_ROUTES.Product.Coaching.Putt.Putt_h.Path);
}
function goToPuttCU() {
  router.push(USER_ROUTES.Product.Coaching.Putt.Putt_u.Path);
}

function goToToccC() {
  router.push(USER_ROUTES.Product.Testing.Tocc.Tocc_e.Path);
}
function goToToccY() {
  router.push(USER_ROUTES.Product.Testing.Tocc.Tocc_h.Path);
}
function goToTecP() {
  router.push(USER_ROUTES.Product.Testing.Tocc.Tec.Path);
}

function goToPuttE() {
  router.push(USER_ROUTES.Product.Testing.Putt.Putt_e.Path);
}
function goToPuttM() {
  router.push(USER_ROUTES.Product.Testing.Putt.Putt_m.Path);
}
function goToPuttH() {
  router.push(USER_ROUTES.Product.Testing.Putt.Putt_h.Path);
}
function goToPuttU() {
  router.push(USER_ROUTES.Product.Testing.Putt.Putt_u.Path);
}

function goToIndividualInstruction() {
  router.push(USER_ROUTES.Instruction.individual.Path);
}

function goToOrgInstruction() {
  router.push(USER_ROUTES.Instruction.org.Path);
}
</script>

<style scoped>
.ori {
  background-image: url("@/assets/img_up/shop_pds/kp708b/design/my_xml/me-in-o-ri1739761770.jpg");
}
.spot_03 {
  position: relative;
  overflow: hidden;
}
.spot_03 .owl-controls {
  margin: 0 !important;
  position: absolute;
  top: 50%;
  margin-top: -10px;
  width: 100%;
  height: auto;
}
.spot_03 .owl-controls .owl-nav .owl-prev,
.spot_03 .owl-controls .owl-nav .owl-next {
  overflow: hidden;
  position: absolute;
  top: 50%;
  z-index: 50;
  width: 40px;
  height: 40px;
  margin-top: -10px;
  cursor: pointer;
  opacity: 0.3;
  box-sizing: border-box;
  text-align: center;
}
.spot_03 .owl-controls .owl-nav .owl-prev:hover,
.spot_03 .owl-controls .owl-nav .owl-next:hover {
  opacity: 0.6;
}
.spot_03 .owl-controls .owl-nav .owl-prev:before,
.spot_03 .owl-controls .owl-nav .owl-next:before {
  display: none;
  line-height: 40px;
  font-family: "icomoon";
  font-size: 20px;
  color: #333;
}
.spot_03 .owl-controls .owl-nav .owl-next {
  right: 20px;
}
.spot_03 .owl-controls .owl-nav .owl-next:before {
  content: "\e923";
}
.spot_03 .owl-controls .owl-nav .owl-prev {
  left: 20px;
}
.spot_03 .owl-controls .owl-nav .owl-prev:before {
  content: "\e922";
}
.spot_03 .owl-controls .owl-dots {
  position: absolute;
  bottom: 10px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
}
.spot_03 .owl-controls .owl-dots .owl-dot {
  position: relative;
  display: inline-block;
  margin: 3px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  box-sizing: border-box;
  background: transparent;
  border: 1px solid #fff;
}
.spot_03 .owl-controls .owl-dots .owl-dot:hover,
.spot_03 .owl-controls .owl-dots .owl-dot.active {
  background: #fff;
}
.spot_03 .owl-controls .owl-dots .owl-dot:hover span,
.spot_03 .owl-controls .owl-dots .owl-dot.active span {
  opacity: 1;
  background: #fff;
}
.carousel .item {
  margin-right: 25px;
}
.spot_03 .item a {
  display: block;
  background-size: auto 270px;
  height: 270px;
  background-position: center center;
  width: auto;
}
.spot_03 .item_caption {
  padding: 20px 0 0 20px;
  width: 100%;
  margin: 0;
  box-sizing: border-box;
}
.spot_03 .item_caption h1 {
  font-size: 15px;
  text-align: center;
  line-height: 1.7em;
  color: #fff;
  font-family: "Noto Sans", NanumGothic, "나눔고딕", "Open Sans", sans-serif;
  font-weight: 800;
  text-shadow: 0px 0px 3px #555;
  word-break: keep-all;
}

@media screen and (min-width: 768px) {
  .spot_03 .owl-controls .owl-dots {
    bottom: 10px;
  }
  .spot_03 .owl-controls .owl-nav .owl-prev:before,
  .spot_03 .owl-controls .owl-nav .owl-next:before {
    display: inline-block;
    font-size: 30px;
  }
  .spot_03 .item a {
    background-size: auto 440px;
    height: 400px;
  }
  .spot_03 .item_caption {
    padding: 150px 0 0 20px;
  }
  .spot_03 .item_caption h1 {
    font-size: 20px;
  }
}
@media screen and (min-width: 1100px) {
  .spot_03 .owl-controls .owl-nav .owl-next {
    right: 100px;
  }
  .spot_03 .owl-controls .owl-nav .owl-prev {
    left: 100px;
  }
  .spot_03 .owl-controls .owl-nav .owl-prev:before,
  .spot_03 .owl-controls .owl-nav .owl-next:before {
    font-size: 50px;
  }
  .spot_03 .item a {
    background-size: auto 570px;
    height: 570px;
  }
  .spot_03 .item_caption {
    padding: 50px 0 0 0;
    width: 1200px;
    margin: 0 auto;
  }
  .spot_03 .item_caption h1 {
    font-size: 20px;
  }
}

.mblock_style_01 * {
  font-family: "Noto Sans", NanumGothic, "나눔고딕", "Open Sans", sans-serif;
  box-sizing: border-box;
  word-break: keep-all;
}
.mblock_style_01 {
  padding: 30px 10px 0 10px;
}
.mblock_style_01 > div > ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.mblock_style_01 > div > ul li {
  width: 48%;
  background: rgba(190, 123, 66, 1);
  border-radius: 10px;
  transition: all 0.2s;
}
.mblock_style_01 > div > ul li:nth-child(-n + 2) {
  margin-bottom: 20px;
}
.mblock_style_01 > div > ul li a {
  display: block;
  padding: 30px 25px;
  position: relative;
}
.mblock_style_01 > div > ul li a > h1 {
  font-size: 16px;
  color: #fff;
  font-weight: 900;
}
.mblock_style_01 > div > ul li a span {
  display: block;
  font-size: 19px;
  color: #fff;
  font-weight: 800;
  margin-bottom: 30px;
}
.mblock_style_01 > div > ul li a i {
  font-family: "Font Awesome 6 Free";
  color: #f5f5f5;
  position: absolute;
  right: 20px;
  top: 30px;
  font-size: 30px;
}

@media all and (min-width: 768px) {
  .mblock_style_01 {
    padding: 40px 10px 0 10px;
  }
  .mblock_style_01 > div > ul li {
    background: rgba(190, 123, 66, 0.6);
  }
  .mblock_style_01 > div > ul li a {
    padding: 40px 30px;
  }
  .mblock_style_01 > div > ul li a > h1 {
    font-size: 22px;
  }
  .mblock_style_01 > div > ul li a span {
    font-size: 18px;
  }
  .mblock_style_01 > div > ul li a i {
    right: 30px;
    bottom: 40px;
    font-size: 30px;
    top: auto;
  }
}
@media all and (min-width: 1100px) {
  .mblock_style_01 {
    position: absolute;
    bottom: 20px;
    left: 0;
    right: 0;
    padding: 0;
  }
  .mblock_style_01 > div > ul li {
    width: 23.5%;
  }
  .mblock_style_01 > div > ul li:nth-child(-n + 3) {
    margin-bottom: 0px;
  }
  .mblock_style_01 > div > ul li:hover {
    background: rgba(190, 123, 66, 1);
  }
}

.mblock_style_02 * {
  font-family: "Noto Sans", NanumGothic, "나눔고딕", "Open Sans", sans-serif;
  box-sizing: border-box;
  word-break: keep-all;
}
.mblock_style_02 {
  padding: 20px 10px;
}
.mblock_style_02 > div > ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.mblock_style_02 > div > ul li {
  width: 100%;
  /* height: 176px; */
  height: auto;
}
.mblock_style_02 > div > ul li:nth-child(-n + 2) {
  margin-bottom: 20px;
}
.mblock_style_02 > div > ul li.box2 a {
  display: block;
  height: 75px;
  background: #c55a1b;
  border-radius: 10px;
  padding: 25px 40px;
  position: relative;
}
.mblock_style_02 > div > ul li.box2 a.btn1 {
  margin-bottom: 10px;
  background: #26593a;
}

.mblock_style_02 > div > ul li.box2 a.btn2 {
  margin-bottom: 10px;
  background: white;
  border: 1px solid #be7b42;
}
.mblock_style_02 > div > ul li.box2 a.btn3 {
  margin-bottom: 10px;
  background: #bdb904;
}
.mblock_style_02 > div > ul li.box2 a.btn4 {
  margin-bottom: 10px;
  background: #be7b42;
}
.mblock_style_02 > div > ul li.box2 a.btn5 {
  margin-bottom: 10px;
  background: #4ab153;
}
.mblock_style_02 > div > ul li.box2 a.btn2 dl {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  font-size: 17px;
  font-weight: 500;
  color: #be7b42;
}

.mblock_style_02 > div > ul li.box2 a dl {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  font-size: 17px;
  font-weight: 500;
  color: #fff;
}
.mblock_style_02 > div > ul li.box2 a dl dt {
  width: 80px;
}
.mblock_style_02 > div > ul li.box2 a dl dd {
  width: calc(100% - 80px);
}
.mblock_style_02 > div > ul li.box2 a i {
  font-family: "Font Awesome 6 Free";
  color: #f5f5f5;
  position: absolute;
  right: 40px;
  transform: translate(-0%, -50%);
  top: 50%;
  font-size: 25px;
}

.mblock_style_02 > div > ul li.box3 {
  background: #b3c228;
  border-radius: 15px;
  padding-top: 70px;
}
.mblock_style_02 > div > ul li.box3 h1 {
  font-weight: 600;
  font-size: 25px;
  text-align: center;
  color: #fff;
}

@media screen and (min-width: 768px) {
  .mblock_style_02 > div > ul li {
    width: 49%;
  }
  .mblock_style_02 > div > ul li:last-child {
    width: 100%;
  }
}
@media screen and (min-width: 1100px) {
  .mblock_style_02 {
    padding: 50px 10px;
  }
  .mblock_style_02 > div > ul li {
    width: 32%;
  }
  .mblock_style_02 > div > ul li:last-child {
    width: 32%;
  }
  .mblock_style_02 > div > ul li:nth-child(-n + 2) {
    margin-bottom: 0px;
  }
}
@media screen and (min-width: 768px) {
  .pm-login_b_login_b .checks label,
  .pm-login_b_login_b .nav a,
  .pm-login_b_login_b .from dt input {
    font-size: 11px;
  }
}

@media screen and (min-width: 1100px) {
  .pm-login_b_login_b .checks label,
  .pm-login_b_login_b .nav a {
    font-size: 13px;
  }
  .pm-login_b_login_b .from dt input {
    font-size: 14px;
  }
}

.mblock_style_03 * {
  font-family: "Noto Sans", NanumGothic, "나눔고딕", "Open Sans", sans-serif;
  box-sizing: border-box;
  word-break: keep-all;
}
.mblock_style_03 {
  padding: 0 10px 30px 10px;
}
.mblock_style_03 > div > ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.mblock_style_03 > div > ul > li {
  width: 100%;
  border-radius: 10px;
  border-top: none;
  border: 1px solid #ddd;
}
.mblock_style_03 > div > ul > li:nth-child(-n + 2) {
  margin-bottom: 20px;
}
.mblock_style_03 > div > ul > li > div {
  padding: 20px;
  border-radius: 0 0 10px 10px;
  background: #fff;
}
.mblock_style_03 > div > ul > li > div.box {
  padding: 20px;
  border-radius: 0 0 10px 10px;
  background: #be7b42;
}
.mblock_style_03 > div > ul > li > div.box > div {
  border-radius: 10px;
  background: #fff;
  padding: 70px 20px;
}
.mblock_style_03 > div > ul > li h1 {
  font-weight: 500;
  font-size: 18px;
  position: relative;
  padding: 12px 30px;
  color: #fff;
  background: #be7b42;
  border-radius: 10px 10px 0 0;
}
.mblock_style_03 > div > ul > li h1 a {
  display: block;
  position: absolute;
  right: 20px;
  top: 12px;
  color: #fff;
  font-size: 15px;
}

@media screen and (min-width: 768px) {
  .mblock_style_03 > div > ul > li {
    width: 32%;
  }
  .mblock_style_03 > div > ul > li:nth-child(-n + 2) {
    margin-bottom: 0px;
  }
}
@media screen and (min-width: 1100px) {
  .mblock_style_03 {
    padding: 0 0 50px 0px;
  }
}

.pm-board_list_mfaq ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.pm-board_list_mfaq li {
  font-size: 15px;
  border-bottom: 1px dashed #ccc;
}

.pm-board_list_mfaq a {
  position: relative;
  font-size: 15px;
  display: block;
  text-decoration: none;
  color: #333;
  font-weight: 500;
  padding: 10px 10px 10px 20px;
}
.pm-board_list_mfaq a:after {
  position: absolute;
  content: "";
  left: 10px;
  top: 18px;
  width: 4px;
  height: 4px;
  background: #555;
}
.pm-board_list_mfaq dl {
  position: relative;
  margin: 0;
  padding-right: 80px;
}
.pm-board_list_mfaq dl dt {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
}
.pm-board_list_mfaq dl dd {
  position: absolute;
  right: 0;
  top: 4px;
  margin: 0;
  font-size: 13px;
  font-weight: normal;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  color: #666;
}
.pm-board_list_mfaq .comment {
  font-weight: normal;
  color: #888;
}
.pm-board_list_mfaq .empty {
  padding: 10px 8px;
  font-size: 14px;
  color: #666;
  text-align: center;
}
@media screen and (min-width: 768px) {
  .pm-board_list_mfaq a {
    padding: 8px 10px 8px 20px;
  }
}
@media screen and (min-width: 1100px) {
  .pm-board_list_mfaq a {
    padding: 10px 10px 10px 20px;
  }
}

.mblock_style_04 * {
  font-family: "Noto Sans", NanumGothic, "나눔고딕", "Open Sans", sans-serif;
  box-sizing: border-box;
  word-break: keep-all;
}
.mblock_style_04 {
  padding: 0 10px 30px 10px;
}
.mblock_style_04 > div > ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.mblock_style_04 > div > ul > li {
  width: 100%;
  border-radius: 10px;
  border-top: none;
  border: 1px solid #ddd;
}
.mblock_style_04 > div > ul > li:nth-child(-n + 2) {
  margin-bottom: 20px;
}
.mblock_style_04 > div > ul > li:nth-child(3) {
  background: #be7b42;
}
.mblock_style_04 > div > ul > li > div {
  padding: 20px;
  border-radius: 0 0 10px 10px;
}
.mblock_style_04 > div > ul > li:nth-child(3) p {
  color: #fff;
  font-size: 13px;
  text-align: center;
  line-height: 1.7em;
}
.mblock_style_04 > div > ul > li:nth-child(3) a {
  border: 1px solid #ddd;
  width: 150px;
  display: block;
  color: #fff;
  margin: 20px auto 0 auto;
  text-align: center;
  border-radius: 5px;
  padding: 9px 0;
  font-size: 15px;
}
.mblock_style_04 > div > ul > li:nth-child(3) a i {
  font-family: "Font Awesome 6 Free";
  font-size: 13px;
  padding-left: 10px;
  vertical-align: 2px;
}
.mblock_style_04 > div > ul > li h1 {
  font-weight: 500;
  font-size: 18px;
  position: relative;
  padding: 12px 30px;
  color: #fff;
  background: #be7b42;
  border-radius: 10px 10px 0 0;
}
.mblock_style_04 > div > ul > li h1 a {
  display: block;
  position: absolute;
  right: 20px;
  top: 12px;
  color: #fff;
  font-size: 15px;
}

@media screen and (min-width: 768px) {
  .mblock_style_04 > div > ul > li {
    width: 32%;
  }
  .mblock_style_04 > div > ul > li:nth-child(-n + 2) {
    margin-bottom: 0px;
  }
}
@media screen and (min-width: 1100px) {
  .mblock_style_04 {
    padding: 0 0 70px 0px;
  }
  .mblock_style_04 > div > ul > li:nth-child(3) p {
    font-size: 15px;
  }
}

.pm-board_list_mnotice ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.pm-board_list_mnotice li {
  font-size: 15px;
  border-bottom: 1px dashed #ccc;
}

.pm-board_list_mnotice a {
  position: relative;
  font-size: 15px;
  display: block;
  text-decoration: none;
  color: #333;
  font-weight: 500;
  padding: 10px 10px 10px 20px;
}
.pm-board_list_mnotice a:after {
  position: absolute;
  content: "";
  left: 10px;
  top: 18px;
  width: 4px;
  height: 4px;
  background: #555;
}
.pm-board_list_mnotice dl {
  position: relative;
  margin: 0;
  padding-right: 80px;
}
.pm-board_list_mnotice dl dt {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
}
.pm-board_list_mnotice dl dd {
  position: absolute;
  right: 0;
  top: 4px;
  margin: 0;
  font-size: 13px;
  font-weight: normal;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  color: #666;
}
.pm-board_list_mnotice .comment {
  font-weight: normal;
  color: #888;
}
.pm-board_list_mnotice .empty {
  padding: 10px 8px;
  font-size: 14px;
  color: #666;
  text-align: center;
}
@media screen and (min-width: 768px) {
  .pm-board_list_mnotice a {
    padding: 8px 10px 8px 20px;
  }
}
@media screen and (min-width: 1100px) {
  .pm-board_list_mnotice a {
    padding: 10px 10px 10px 20px;
  }
}
.pm-board_list_mboard ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.pm-board_list_mboard li {
  font-size: 15px;
  border-bottom: 1px dashed #ccc;
}

.pm-board_list_mboard a {
  position: relative;
  font-size: 15px;
  display: block;
  text-decoration: none;
  color: #333;
  font-weight: 500;
  padding: 10px 10px 10px 20px;
}
.pm-board_list_mboard a:after {
  position: absolute;
  content: "";
  left: 10px;
  top: 18px;
  width: 4px;
  height: 4px;
  background: #555;
}
.pm-board_list_mboard dl {
  position: relative;
  margin: 0;
  padding-right: 80px;
}
.pm-board_list_mboard dl dt {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
}
.pm-board_list_mboard dl dd {
  position: absolute;
  right: 0;
  top: 4px;
  margin: 0;
  font-size: 13px;
  font-weight: normal;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  color: #666;
}
.pm-board_list_mboard .comment {
  font-weight: normal;
  color: #888;
}
.pm-board_list_mboard .empty {
  padding: 10px 8px;
  font-size: 14px;
  color: #666;
  text-align: center;
}
@media screen and (min-width: 768px) {
  .pm-board_list_mboard a {
    padding: 8px 10px 8px 20px;
  }
}
@media screen and (min-width: 1100px) {
  .pm-board_list_mboard a {
    padding: 10px 10px 10px 20px;
  }
}

.mblock_05 * {
  font-family: "Noto Sans", NanumGothic, "나눔고딕", "Open Sans", sans-serif;
  box-sizing: border-box;
  word-break: keep-all;
}
.mblock_05 > div {
  padding: 50px 10px;
}
.mblock_05 > div:nth-child(odd) {
  background: #f5f5f5;
}
.mblock_05 > div > div > dl > dt > h1 {
  font-size: 19px;
  text-align: center;
  font-weight: 600;
  margin-bottom: 40px;
}
.mblock_05 > div > div > dl > dt > h1 span {
  font-size: 14px;
  display: block;
  font-weight: 500;
  padding-top: 15px;
  line-height: 1.7em;
}

@media screen and (min-width: 768px) {
  .mblock_05 > div > div > dl > dt > h1 {
    font-size: 22px;
  }
  .mblock_05 > div > div > dl > dt > h1 span {
    font-size: 15px;
  }
}
@media screen and (min-width: 1100px) {
  .mblock_05 > div {
    padding: 50px 0px;
  }
}

.pm-myboard_slide_responsive_myboard1 {
  max-width: 1200px;
  margin: 0 auto;
}
.pm-myboard_slide_responsive_myboard1 a {
  display: block;
  border: none;
  position: relative;
}
.pm-myboard_slide_responsive_myboard1 .owl-item {
  z-index: 1;
}
.pm-myboard_slide_responsive_myboard1 .item {
  position: relative;
}
.pm-myboard_slide_responsive_myboard1 .item .figure {
  border: 1px solid #ddd;
}
.pm-myboard_slide_responsive_myboard1 .item p {
  font-size: 14px;
  padding-top: 10px;
  text-align: center;
}
.pm-myboard_slide_responsive_myboard1 .owl-nav {
  -webkit-tap-highlight-color: transparent;
}
.pm-myboard_slide_responsive_myboard1 .owl-nav [class*="owl-"] {
  position: absolute;
  top: 50%;
  z-index: 2;
  width: 40px;
  height: 40px;
  line-height: 40px;
  margin-top: -20px;
  font-size: 0;
  cursor: pointer;
  opacity: 0.7;
}
.pm-myboard_slide_responsive_myboard1 .owl-nav [class*="owl-"]:before {
  font-family: "icomoon_slider";
  font-size: 40px;
  font-weight: bold;
  color: #fff;
}
.pm-myboard_slide_responsive_myboard1 .owl-nav [class*="owl-"]:hover {
  opacity: 1;
}
.pm-myboard_slide_responsive_myboard1 .owl-nav .owl-prev {
  left: 5px;
}
.pm-myboard_slide_responsive_myboard1 .owl-nav .owl-next {
  right: 5px;
}
.pm-myboard_slide_responsive_myboard1 .owl-nav .owl-prev:before {
  content: "\e600";
}
.pm-myboard_slide_responsive_myboard1 .owl-nav .owl-next:before {
  content: "\e601";
}
.pm-myboard_slide_responsive_myboard1 .owl-nav .disabled {
  opacity: 0.5;
  cursor: default;
}

.pm-myboard_slide_responsive_myboard1 .owl-dots {
  position: absolute;
  left: 0;
  width: 100%;
  height: 30px;
  padding: 10px;
  font-size: 0;
  box-sizing: border-box;
  text-align: center;
}
.pm-myboard_slide_responsive_myboard1 .owl-dots .owl-dot {
  display: inline-block;
}
.pm-myboard_slide_responsive_myboard1 .owl-dots .owl-dot span {
  display: block;
  width: 10px;
  height: 10px;
  margin: 0 4px;
  background: #ddd;
  border-radius: 30px;
  transition: opacity 200ms ease;
}
.pm-myboard_slide_responsive_myboard1 .owl-dots .owl-dot.active span,
.pm-myboard_slide_responsive_myboard1 .owl-dots .owl-dot:hover span {
  background: #999;
}

.pm-myboard_slide_responsive_myboard1 .item > a > div.bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: none;
  opacity: 0;
  transition: all.2s;
}
.pm-myboard_slide_responsive_myboard1 .item > a > div.bg > span {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  line-height: 80px;
  text-align: center;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  top: 50%;
  background: #ba7b3d;
  color: #fff;
  font-weight: 500;
}

@media screen and (min-width: 1100px) {
  .pm-myboard_slide_responsive_myboard1 .item > a:hover > div.bg {
    display: block;
    opacity: 1;
  }
}

.pm-myboard_slide_responsive_myboard2 {
  max-width: 1200px;
  margin: 0 auto;
}
.pm-myboard_slide_responsive_myboard2 a {
  display: block;
  border: none;
  position: relative;
}
.pm-myboard_slide_responsive_myboard2 .owl-item {
  z-index: 1;
}
.pm-myboard_slide_responsive_myboard2 .item {
  position: relative;
}
.pm-myboard_slide_responsive_myboard2 .item .figure {
  border: 1px solid #ddd;
}
.pm-myboard_slide_responsive_myboard2 .item p {
  font-size: 14px;
  padding-top: 10px;
  text-align: center;
}
.pm-myboard_slide_responsive_myboard2 .owl-nav {
  -webkit-tap-highlight-color: transparent;
}
.pm-myboard_slide_responsive_myboard2 .owl-nav [class*="owl-"] {
  position: absolute;
  top: 50%;
  z-index: 2;
  width: 40px;
  height: 40px;
  line-height: 40px;
  margin-top: -20px;
  font-size: 0;
  cursor: pointer;
  opacity: 0.7;
}
.pm-myboard_slide_responsive_myboard2 .owl-nav [class*="owl-"]:before {
  font-family: "icomoon_slider";
  font-size: 40px;
  font-weight: bold;
  color: #fff;
}
.pm-myboard_slide_responsive_myboard2 .owl-nav [class*="owl-"]:hover {
  opacity: 1;
}
.pm-myboard_slide_responsive_myboard2 .owl-nav .owl-prev {
  left: 5px;
}
.pm-myboard_slide_responsive_myboard2 .owl-nav .owl-next {
  right: 5px;
}
.pm-myboard_slide_responsive_myboard2 .owl-nav .owl-prev:before {
  content: "\e600";
}
.pm-myboard_slide_responsive_myboard2 .owl-nav .owl-next:before {
  content: "\e601";
}
.pm-myboard_slide_responsive_myboard2 .owl-nav .disabled {
  opacity: 0.5;
  cursor: default;
}

.pm-myboard_slide_responsive_myboard2 .owl-dots {
  position: absolute;
  left: 0;
  width: 100%;
  height: 30px;
  padding: 10px;
  font-size: 0;
  box-sizing: border-box;
  text-align: center;
}
.pm-myboard_slide_responsive_myboard2 .owl-dots .owl-dot {
  display: inline-block;
}
.pm-myboard_slide_responsive_myboard2 .owl-dots .owl-dot span {
  display: block;
  width: 10px;
  height: 10px;
  margin: 0 4px;
  background: #ddd;
  border-radius: 30px;
  transition: opacity 200ms ease;
}
.pm-myboard_slide_responsive_myboard2 .owl-dots .owl-dot.active span,
.pm-myboard_slide_responsive_myboard2 .owl-dots .owl-dot:hover span {
  background: #999;
}

.pm-myboard_slide_responsive_myboard2 .item > a > div.bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: none;
  opacity: 0;
  transition: all.2s;
}
.pm-myboard_slide_responsive_myboard2 .item > a > div.bg > span {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  line-height: 80px;
  text-align: center;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  top: 50%;
  background: #ba7b3d;
  color: #fff;
  font-weight: 500;
}

@media screen and (min-width: 1100px) {
  .pm-myboard_slide_responsive_myboard2 .item > a:hover > div.bg {
    display: block;
    opacity: 1;
  }
}

.mblock_06 * {
  font-family: "Noto Sans", NanumGothic, "나눔고딕", "Open Sans", sans-serif;
  box-sizing: border-box;
  word-break: keep-all;
}
.mblock_06 {
  padding: 0 10px 40px 10px;
}
.mblock_06 > h1 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 30px;
  text-align: center;
}
.mblock_06 > div > div.box1 {
  margin-bottom: 30px;
}
.mblock_06 > div > div h2 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
}
.mblock_06 > div > div > ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.mblock_06 > div > div > ul > li {
  width: 100%;
  border: 1px solid #ddd;
  padding: 20px;
  border-radius: 10px;
  position: relative;
}
.mblock_06 > div > div > ul > li:after {
  content: "";
  display: block;
  width: 0;
  height: 0;
}
.mblock_06 > div > div > ul > li:last-child:after {
  display: none;
}
.mblock_06 > div > div > ul > li:nth-child(-n + 2) {
  margin-bottom: 30px;
}
.mblock_06 > div > div > ul > li h3 {
  font-weight: 500;
  font-size: 17px;
  margin-bottom: 15px;
  text-align: center;
}
.mblock_06 > div > div > ul > li > ul > li {
  font-size: 14px;
  list-style: circle;
  margin-left: 1.2em;
  margin-bottom: 5px;
  line-height: 1.7em;
}
.mblock_06 > div > div > ul > li > ul > li:last-child {
  margin-bottom: 0;
}
.mblock_06 > div > div > ul > li > ul > li span {
  padding: 0px 4px;
  display: inline-block;
  color: #fff;
  border-radius: 3px;
}
.mblock_06 > div > div > ul > li > ul > li span.green {
  background: #ba7b3d;
}
.mblock_06 > div > div > ul > li > ul > li span.red {
  background: #ff0000;
}
.mblock_06 > div > div > ul > li > ul > li span.blue {
  background: #0000ff;
}
.mblock_06 > div > div > ul > li > ul > li.check {
  list-style: none;
  color: #028cd7;
  margin-left: 0;
}
@media screen and (max-width: 767px) {
  .mblock_06 > div > div > ul > li:after {
    border: 10px solid transparent;
    border-bottom: none;
    border-top-color: #ddd;
    position: absolute;
    bottom: -10px;
    left: 50%;
    margin-left: -8px;
  }
}
@media screen and (min-width: 768px) {
  .mblock_06 {
    padding: 0 0 50px 0;
  }
  .mblock_06 > h1 {
    font-size: 22px;
  }
  .mblock_06 > div > div > ul > li {
    width: 45%;
  }
  .mblock_06 > div > div > ul > li:after {
    border: 10px solid transparent;
    border-right: none;
    border-left-color: #ddd;
    position: absolute;
    right: -10px;
    top: 50%;
    transform: translate(-0%, -50%);
  }
  .mblock_06 > div > div > ul > li:nth-child(-n + 1) {
    margin-bottom: 0px;
  }
}

.mblock_07 * {
  font-family: "Noto Sans", NanumGothic, "나눔고딕", "Open Sans", sans-serif;
  box-sizing: border-box;
  word-break: keep-all;
}
.mblock_07 {
  padding: 0 10px 40px 10px;
}
.mblock_07 > h1 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 30px;
  text-align: center;
}
.mblock_07 > div > div.box1 {
  margin-bottom: 30px;
}
.mblock_07 > div > div h2 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
}
.mblock_07 > div > div > ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.mblock_07 > div > div > ul > li {
  width: 100%;
  border: 1px solid #ddd;
  padding: 20px;
  border-radius: 10px;
  position: relative;
}
.mblock_07 > div > div > ul > li:after {
  content: "";
  display: block;
  width: 0;
  height: 0;
}
.mblock_07 > div > div > ul > li:last-child:after {
  display: none;
}
.mblock_07 > div > div > ul > li:nth-child(-n + 1) {
  margin-bottom: 30px;
}
.mblock_07 > div > div > ul > li h3 {
  font-weight: 500;
  font-size: 17px;
  margin-bottom: 15px;
  text-align: center;
}
.mblock_07 > div > div > ul > li > ul > li {
  font-size: 14px;
  list-style: circle;
  margin-left: 1.2em;
  margin-bottom: 5px;
  line-height: 1.7em;
}
.mblock_07 > div > div > ul > li > ul > li:last-child {
  margin-bottom: 0;
}
.mblock_07 > div > div > ul > li > ul > li span {
  padding: 0px 4px;
  display: inline-block;
  color: #fff;
  border-radius: 3px;
}
.mblock_07 > div > div > ul > li > ul > li span.green {
  background: #ba7b3d;
}
.mblock_07 > div > div > ul > li > ul > li span.red {
  background: #ff0000;
}
.mblock_07 > div > div > ul > li > ul > li.check {
  list-style: none;
  color: #028cd7;
  margin-left: 0;
}
@media screen and (max-width: 767px) {
  .mblock_07 > div > div > ul > li:after {
    border: 10px solid transparent;
    border-bottom: none;
    border-top-color: #ddd;
    position: absolute;
    bottom: -10px;
    left: 50%;
    margin-left: -8px;
  }
}
@media screen and (min-width: 768px) {
  .mblock_07 {
    padding: 0 0 50px 0;
  }
  .mblock_07 > h1 {
    font-size: 22px;
  }
  .mblock_07 > div > div > ul > li {
    width: 49%;
  }
  .mblock_07 > div > div > ul > li:after {
    border: 10px solid transparent;
    border-right: none;
    border-left-color: #ddd;
    position: absolute;
    right: -10px;
    top: 50%;
    transform: translate(-0%, -50%);
  }
  .mblock_07 > div > div > ul > li:nth-child(-n + 1) {
    margin-bottom: 0px;
  }
  .mblock_07 > div > div > ul > li > ul > li {
    margin-left: 8.2em;
  }
  .mblock_07 > div > div > ul > li > ul > li.check {
    margin-left: 8.2em;
  }
}

.pm-myboard_slide_responsive_myboard6 {
  max-width: 1200px;
  margin: 0 auto;
}
.pm-myboard_slide_responsive_myboard6 a {
  display: block;
  border: none;
  position: relative;
}
.pm-myboard_slide_responsive_myboard6 .owl-item {
  z-index: 1;
}
.pm-myboard_slide_responsive_myboard6 .item {
  position: relative;
}
.pm-myboard_slide_responsive_myboard6 .item .figure {
  border: 1px solid #ddd;
}
.pm-myboard_slide_responsive_myboard6 .item p {
  font-size: 14px;
  padding-top: 10px;
  text-align: center;
}
.pm-myboard_slide_responsive_myboard6 .owl-nav {
  -webkit-tap-highlight-color: transparent;
}
.pm-myboard_slide_responsive_myboard6 .owl-nav [class*="owl-"] {
  position: absolute;
  top: 50%;
  z-index: 2;
  width: 40px;
  height: 40px;
  line-height: 40px;
  margin-top: -20px;
  font-size: 0;
  cursor: pointer;
  opacity: 0.7;
}
.pm-myboard_slide_responsive_myboard6 .owl-nav [class*="owl-"]:before {
  font-family: "icomoon_slider";
  font-size: 40px;
  font-weight: bold;
  color: #fff;
}
.pm-myboard_slide_responsive_myboard6 .owl-nav [class*="owl-"]:hover {
  opacity: 1;
}
.pm-myboard_slide_responsive_myboard6 .owl-nav .owl-prev {
  left: 5px;
}
.pm-myboard_slide_responsive_myboard6 .owl-nav .owl-next {
  right: 5px;
}
.pm-myboard_slide_responsive_myboard6 .owl-nav .owl-prev:before {
  content: "\e600";
}
.pm-myboard_slide_responsive_myboard6 .owl-nav .owl-next:before {
  content: "\e601";
}
.pm-myboard_slide_responsive_myboard6 .owl-nav .disabled {
  opacity: 0.5;
  cursor: default;
}

.pm-myboard_slide_responsive_myboard6 .owl-dots {
  position: absolute;
  left: 0;
  width: 100%;
  height: 30px;
  padding: 10px;
  font-size: 0;
  box-sizing: border-box;
  text-align: center;
}
.pm-myboard_slide_responsive_myboard6 .owl-dots .owl-dot {
  display: inline-block;
}
.pm-myboard_slide_responsive_myboard6 .owl-dots .owl-dot span {
  display: block;
  width: 10px;
  height: 10px;
  margin: 0 4px;
  background: #ddd;
  border-radius: 30px;
  transition: opacity 200ms ease;
}
.pm-myboard_slide_responsive_myboard6 .owl-dots .owl-dot.active span,
.pm-myboard_slide_responsive_myboard6 .owl-dots .owl-dot:hover span {
  background: #999;
}

.pm-myboard_slide_responsive_myboard6 .item > a > div.bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: none;
  opacity: 0;
  transition: all.2s;
}
.pm-myboard_slide_responsive_myboard6 .item > a > div.bg > span {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  line-height: 80px;
  text-align: center;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  top: 50%;
  background: #ba7b3d;
  color: #fff;
  font-weight: 500;
}

@media screen and (min-width: 1100px) {
  .pm-myboard_slide_responsive_myboard6 .item > a:hover > div.bg {
    display: block;
    opacity: 1;
  }
}

.pm-myboard_slide_responsive_myboard8 {
  max-width: 1200px;
  margin: 0 auto;
}
.pm-myboard_slide_responsive_myboard8 a {
  display: block;
  border: none;
  position: relative;
}
.pm-myboard_slide_responsive_myboard8 .owl-item {
  z-index: 1;
}
.pm-myboard_slide_responsive_myboard8 .item {
  position: relative;
}
.pm-myboard_slide_responsive_myboard8 .item .figure {
  border: 1px solid #ddd;
}
.pm-myboard_slide_responsive_myboard8 .item p {
  font-size: 14px;
  padding-top: 10px;
  text-align: center;
}
.pm-myboard_slide_responsive_myboard8 .owl-nav {
  -webkit-tap-highlight-color: transparent;
}
.pm-myboard_slide_responsive_myboard8 .owl-nav [class*="owl-"] {
  position: absolute;
  top: 50%;
  z-index: 2;
  width: 40px;
  height: 40px;
  line-height: 40px;
  margin-top: -20px;
  font-size: 0;
  cursor: pointer;
  opacity: 0.7;
}
.pm-myboard_slide_responsive_myboard8 .owl-nav [class*="owl-"]:before {
  font-family: "icomoon_slider";
  font-size: 40px;
  font-weight: bold;
  color: #fff;
}
.pm-myboard_slide_responsive_myboard8 .owl-nav [class*="owl-"]:hover {
  opacity: 1;
}
.pm-myboard_slide_responsive_myboard8 .owl-nav .owl-prev {
  left: 5px;
}
.pm-myboard_slide_responsive_myboard8 .owl-nav .owl-next {
  right: 5px;
}
.pm-myboard_slide_responsive_myboard8 .owl-nav .owl-prev:before {
  content: "\e600";
}
.pm-myboard_slide_responsive_myboard8 .owl-nav .owl-next:before {
  content: "\e601";
}
.pm-myboard_slide_responsive_myboard8 .owl-nav .disabled {
  opacity: 0.5;
  cursor: default;
}

.pm-myboard_slide_responsive_myboard8 .owl-dots {
  position: absolute;
  left: 0;
  width: 100%;
  height: 30px;
  padding: 10px;
  font-size: 0;
  box-sizing: border-box;
  text-align: center;
}
.pm-myboard_slide_responsive_myboard8 .owl-dots .owl-dot {
  display: inline-block;
}
.pm-myboard_slide_responsive_myboard8 .owl-dots .owl-dot span {
  display: block;
  width: 10px;
  height: 10px;
  margin: 0 4px;
  background: #ddd;
  border-radius: 30px;
  transition: opacity 200ms ease;
}
.pm-myboard_slide_responsive_myboard8 .owl-dots .owl-dot.active span,
.pm-myboard_slide_responsive_myboard8 .owl-dots .owl-dot:hover span {
  background: #999;
}

.pm-myboard_slide_responsive_myboard8 .item > a > div.bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: none;
  opacity: 0;
  transition: all.2s;
}
.pm-myboard_slide_responsive_myboard8 .item > a > div.bg > span {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  line-height: 80px;
  text-align: center;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  top: 50%;
  background: #ba7b3d;
  color: #fff;
  font-weight: 500;
}

@media screen and (min-width: 1100px) {
  .pm-myboard_slide_responsive_myboard8 .item > a:hover > div.bg {
    display: block;
    opacity: 1;
  }
}

.pm-myboard_slide_responsive_myboard3 {
  max-width: 1200px;
  margin: 0 auto;
}
.pm-myboard_slide_responsive_myboard3 a {
  display: block;
  border: none;
  position: relative;
}
.pm-myboard_slide_responsive_myboard3 .owl-item {
  z-index: 1;
}
.pm-myboard_slide_responsive_myboard3 .item {
  position: relative;
}
.pm-myboard_slide_responsive_myboard3 .item .figure {
  border: 1px solid #ddd;
}
.pm-myboard_slide_responsive_myboard3 .item p {
  font-size: 14px;
  padding-top: 10px;
  text-align: center;
}
.pm-myboard_slide_responsive_myboard3 .owl-nav {
  -webkit-tap-highlight-color: transparent;
}
.pm-myboard_slide_responsive_myboard3 .owl-nav [class*="owl-"] {
  position: absolute;
  top: 50%;
  z-index: 2;
  width: 40px;
  height: 40px;
  line-height: 40px;
  margin-top: -20px;
  font-size: 0;
  cursor: pointer;
  opacity: 0.7;
}
.pm-myboard_slide_responsive_myboard3 .owl-nav [class*="owl-"]:before {
  font-family: "icomoon_slider";
  font-size: 40px;
  font-weight: bold;
  color: #fff;
}
.pm-myboard_slide_responsive_myboard3 .owl-nav [class*="owl-"]:hover {
  opacity: 1;
}
.pm-myboard_slide_responsive_myboard3 .owl-nav .owl-prev {
  left: 5px;
}
.pm-myboard_slide_responsive_myboard3 .owl-nav .owl-next {
  right: 5px;
}
.pm-myboard_slide_responsive_myboard3 .owl-nav .owl-prev:before {
  content: "\e600";
}
.pm-myboard_slide_responsive_myboard3 .owl-nav .owl-next:before {
  content: "\e601";
}
.pm-myboard_slide_responsive_myboard3 .owl-nav .disabled {
  opacity: 0.5;
  cursor: default;
}

.pm-myboard_slide_responsive_myboard3 .owl-dots {
  position: absolute;
  left: 0;
  width: 100%;
  height: 30px;
  padding: 10px;
  font-size: 0;
  box-sizing: border-box;
  text-align: center;
}
.pm-myboard_slide_responsive_myboard3 .owl-dots .owl-dot {
  display: inline-block;
}
.pm-myboard_slide_responsive_myboard3 .owl-dots .owl-dot span {
  display: block;
  width: 10px;
  height: 10px;
  margin: 0 4px;
  background: #ddd;
  border-radius: 30px;
  transition: opacity 200ms ease;
}
.pm-myboard_slide_responsive_myboard3 .owl-dots .owl-dot.active span,
.pm-myboard_slide_responsive_myboard3 .owl-dots .owl-dot:hover span {
  background: #999;
}

.pm-myboard_slide_responsive_myboard3 .item > a > div.bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: none;
  opacity: 0;
  transition: all.2s;
}
.pm-myboard_slide_responsive_myboard3 .item > a > div.bg > span {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  line-height: 80px;
  text-align: center;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  top: 50%;
  background: #ba7b3d;
  color: #fff;
  font-weight: 500;
}

@media screen and (min-width: 1100px) {
  .pm-myboard_slide_responsive_myboard3 .item > a:hover > div.bg {
    display: block;
    opacity: 1;
  }
}

.pm-myboard_slide_responsive_myboard4 {
  max-width: 1200px;
  margin: 0 auto;
}
.pm-myboard_slide_responsive_myboard4 a {
  display: block;
  border: none;
  position: relative;
}
.pm-myboard_slide_responsive_myboard4 .owl-item {
  z-index: 1;
}
.pm-myboard_slide_responsive_myboard4 .item {
  position: relative;
}
.pm-myboard_slide_responsive_myboard4 .item .figure {
  border: 1px solid #ddd;
}
.pm-myboard_slide_responsive_myboard4 .item p {
  font-size: 14px;
  padding-top: 10px;
  text-align: center;
}
.pm-myboard_slide_responsive_myboard4 .owl-nav {
  -webkit-tap-highlight-color: transparent;
}
.pm-myboard_slide_responsive_myboard4 .owl-nav [class*="owl-"] {
  position: absolute;
  top: 50%;
  z-index: 2;
  width: 40px;
  height: 40px;
  line-height: 40px;
  margin-top: -20px;
  font-size: 0;
  cursor: pointer;
  opacity: 0.7;
}
.pm-myboard_slide_responsive_myboard4 .owl-nav [class*="owl-"]:before {
  font-family: "icomoon_slider";
  font-size: 40px;
  font-weight: bold;
  color: #fff;
}
.pm-myboard_slide_responsive_myboard4 .owl-nav [class*="owl-"]:hover {
  opacity: 1;
}
.pm-myboard_slide_responsive_myboard4 .owl-nav .owl-prev {
  left: 5px;
}
.pm-myboard_slide_responsive_myboard4 .owl-nav .owl-next {
  right: 5px;
}
.pm-myboard_slide_responsive_myboard4 .owl-nav .owl-prev:before {
  content: "\e600";
}
.pm-myboard_slide_responsive_myboard4 .owl-nav .owl-next:before {
  content: "\e601";
}
.pm-myboard_slide_responsive_myboard4 .owl-nav .disabled {
  opacity: 0.5;
  cursor: default;
}

.pm-myboard_slide_responsive_myboard4 .owl-dots {
  position: absolute;
  left: 0;
  width: 100%;
  height: 30px;
  padding: 10px;
  font-size: 0;
  box-sizing: border-box;
  text-align: center;
}
.pm-myboard_slide_responsive_myboard4 .owl-dots .owl-dot {
  display: inline-block;
}
.pm-myboard_slide_responsive_myboard4 .owl-dots .owl-dot span {
  display: block;
  width: 10px;
  height: 10px;
  margin: 0 4px;
  background: #ddd;
  border-radius: 30px;
  transition: opacity 200ms ease;
}
.pm-myboard_slide_responsive_myboard4 .owl-dots .owl-dot.active span,
.pm-myboard_slide_responsive_myboard4 .owl-dots .owl-dot:hover span {
  background: #999;
}

.pm-myboard_slide_responsive_myboard4 .item > a > div.bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: none;
  opacity: 0;
  transition: all.2s;
}
.pm-myboard_slide_responsive_myboard4 .item > a > div.bg > span {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  line-height: 80px;
  text-align: center;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  top: 50%;
  background: #ba7b3d;
  color: #fff;
  font-weight: 500;
}

@media screen and (min-width: 1100px) {
  .pm-myboard_slide_responsive_myboard4 .item > a:hover > div.bg {
    display: block;
    opacity: 1;
  }
}

.pm-myboard_slide_responsive_myboard5 {
  max-width: 1200px;
  margin: 0 auto;
}
.pm-myboard_slide_responsive_myboard5 a {
  display: block;
  border: none;
  position: relative;
}
.pm-myboard_slide_responsive_myboard5 .owl-item {
  z-index: 1;
}
.pm-myboard_slide_responsive_myboard5 .item {
  position: relative;
}
.pm-myboard_slide_responsive_myboard5 .item .figure {
  border: 1px solid #ddd;
}
.pm-myboard_slide_responsive_myboard5 .item p {
  font-size: 14px;
  padding-top: 10px;
  text-align: center;
}
.pm-myboard_slide_responsive_myboard5 .owl-nav {
  -webkit-tap-highlight-color: transparent;
}
.pm-myboard_slide_responsive_myboard5 .owl-nav [class*="owl-"] {
  position: absolute;
  top: 50%;
  z-index: 2;
  width: 40px;
  height: 40px;
  line-height: 40px;
  margin-top: -20px;
  font-size: 0;
  cursor: pointer;
  opacity: 0.7;
}
.pm-myboard_slide_responsive_myboard5 .owl-nav [class*="owl-"]:before {
  font-family: "icomoon_slider";
  font-size: 40px;
  font-weight: bold;
  color: #fff;
}
.pm-myboard_slide_responsive_myboard5 .owl-nav [class*="owl-"]:hover {
  opacity: 1;
}
.pm-myboard_slide_responsive_myboard5 .owl-nav .owl-prev {
  left: 5px;
}
.pm-myboard_slide_responsive_myboard5 .owl-nav .owl-next {
  right: 5px;
}
.pm-myboard_slide_responsive_myboard5 .owl-nav .owl-prev:before {
  content: "\e600";
}
.pm-myboard_slide_responsive_myboard5 .owl-nav .owl-next:before {
  content: "\e601";
}
.pm-myboard_slide_responsive_myboard5 .owl-nav .disabled {
  opacity: 0.5;
  cursor: default;
}

.pm-myboard_slide_responsive_myboard5 .owl-dots {
  position: absolute;
  left: 0;
  width: 100%;
  height: 30px;
  padding: 10px;
  font-size: 0;
  box-sizing: border-box;
  text-align: center;
}
.pm-myboard_slide_responsive_myboard5 .owl-dots .owl-dot {
  display: inline-block;
}
.pm-myboard_slide_responsive_myboard5 .owl-dots .owl-dot span {
  display: block;
  width: 10px;
  height: 10px;
  margin: 0 4px;
  background: #ddd;
  border-radius: 30px;
  transition: opacity 200ms ease;
}
.pm-myboard_slide_responsive_myboard5 .owl-dots .owl-dot.active span,
.pm-myboard_slide_responsive_myboard5 .owl-dots .owl-dot:hover span {
  background: #999;
}

.pm-myboard_slide_responsive_myboard5 .item > a > div.bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: none;
  opacity: 0;
  transition: all.2s;
}
.pm-myboard_slide_responsive_myboard5 .item > a > div.bg > span {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  line-height: 80px;
  text-align: center;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  top: 50%;
  background: #ba7b3d;
  color: #fff;
  font-weight: 500;
}

@media screen and (min-width: 1100px) {
  .pm-myboard_slide_responsive_myboard5 .item > a:hover > div.bg {
    display: block;
    opacity: 1;
  }
}

.pm-myboard_slide_responsive_myboard9 {
  max-width: 1200px;
  margin: 0 auto;
}
.pm-myboard_slide_responsive_myboard9 a {
  display: block;
  border: none;
  position: relative;
}
.pm-myboard_slide_responsive_myboard9 .owl-item {
  z-index: 1;
}
.pm-myboard_slide_responsive_myboard9 .item {
  position: relative;
}
.pm-myboard_slide_responsive_myboard9 .item .figure {
  border: 1px solid #ddd;
}
.pm-myboard_slide_responsive_myboard9 .item p {
  font-size: 14px;
  padding-top: 10px;
  text-align: center;
}
.pm-myboard_slide_responsive_myboard9 .owl-nav {
  -webkit-tap-highlight-color: transparent;
}
.pm-myboard_slide_responsive_myboard9 .owl-nav [class*="owl-"] {
  position: absolute;
  top: 50%;
  z-index: 2;
  width: 40px;
  height: 40px;
  line-height: 40px;
  margin-top: -20px;
  font-size: 0;
  cursor: pointer;
  opacity: 0.7;
}
.pm-myboard_slide_responsive_myboard9 .owl-nav [class*="owl-"]:before {
  font-family: "icomoon_slider";
  font-size: 40px;
  font-weight: bold;
  color: #fff;
}
.pm-myboard_slide_responsive_myboard9 .owl-nav [class*="owl-"]:hover {
  opacity: 1;
}
.pm-myboard_slide_responsive_myboard9 .owl-nav .owl-prev {
  left: 5px;
}
.pm-myboard_slide_responsive_myboard9 .owl-nav .owl-next {
  right: 5px;
}
.pm-myboard_slide_responsive_myboard9 .owl-nav .owl-prev:before {
  content: "\e600";
}
.pm-myboard_slide_responsive_myboard9 .owl-nav .owl-next:before {
  content: "\e601";
}
.pm-myboard_slide_responsive_myboard9 .owl-nav .disabled {
  opacity: 0.5;
  cursor: default;
}

.pm-myboard_slide_responsive_myboard9 .owl-dots {
  position: absolute;
  left: 0;
  width: 100%;
  height: 30px;
  padding: 10px;
  font-size: 0;
  box-sizing: border-box;
  text-align: center;
}
.pm-myboard_slide_responsive_myboard9 .owl-dots .owl-dot {
  display: inline-block;
}
.pm-myboard_slide_responsive_myboard9 .owl-dots .owl-dot span {
  display: block;
  width: 10px;
  height: 10px;
  margin: 0 4px;
  background: #ddd;
  border-radius: 30px;
  transition: opacity 200ms ease;
}
.pm-myboard_slide_responsive_myboard9 .owl-dots .owl-dot.active span,
.pm-myboard_slide_responsive_myboard9 .owl-dots .owl-dot:hover span {
  background: #999;
}

.pm-myboard_slide_responsive_myboard9 .item > a > div.bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: none;
  opacity: 0;
  transition: all.2s;
}
.pm-myboard_slide_responsive_myboard9 .item > a > div.bg > span {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  line-height: 80px;
  text-align: center;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  top: 50%;
  background: #ba7b3d;
  color: #fff;
  font-weight: 500;
}

@media screen and (min-width: 1100px) {
  .pm-myboard_slide_responsive_myboard9 .item > a:hover > div.bg {
    display: block;
    opacity: 1;
  }
}

.pm-myboard_slide_responsive_myboard7 {
  max-width: 1200px;
  margin: 0 auto;
}
.pm-myboard_slide_responsive_myboard7 a {
  display: block;
  border: none;
  position: relative;
}
.pm-myboard_slide_responsive_myboard7 .owl-item {
  z-index: 1;
}
.pm-myboard_slide_responsive_myboard7 .item {
  position: relative;
}
.pm-myboard_slide_responsive_myboard7 .item .figure {
  border: 1px solid #ddd;
}
.pm-myboard_slide_responsive_myboard7 .item p {
  font-size: 14px;
  padding-top: 10px;
  text-align: center;
}
.pm-myboard_slide_responsive_myboard7 .owl-nav {
  -webkit-tap-highlight-color: transparent;
}
.pm-myboard_slide_responsive_myboard7 .owl-nav [class*="owl-"] {
  position: absolute;
  top: 50%;
  z-index: 2;
  width: 40px;
  height: 40px;
  line-height: 40px;
  margin-top: -20px;
  font-size: 0;
  cursor: pointer;
  opacity: 0.7;
}
.pm-myboard_slide_responsive_myboard7 .owl-nav [class*="owl-"]:before {
  font-family: "icomoon_slider";
  font-size: 40px;
  font-weight: bold;
  color: #fff;
}
.pm-myboard_slide_responsive_myboard7 .owl-nav [class*="owl-"]:hover {
  opacity: 1;
}
.pm-myboard_slide_responsive_myboard7 .owl-nav .owl-prev {
  left: 5px;
}
.pm-myboard_slide_responsive_myboard7 .owl-nav .owl-next {
  right: 5px;
}
.pm-myboard_slide_responsive_myboard7 .owl-nav .owl-prev:before {
  content: "\e600";
}
.pm-myboard_slide_responsive_myboard7 .owl-nav .owl-next:before {
  content: "\e601";
}
.pm-myboard_slide_responsive_myboard7 .owl-nav .disabled {
  opacity: 0.5;
  cursor: default;
}

.pm-myboard_slide_responsive_myboard7 .owl-dots {
  position: absolute;
  left: 0;
  width: 100%;
  height: 30px;
  padding: 10px;
  font-size: 0;
  box-sizing: border-box;
  text-align: center;
}
.pm-myboard_slide_responsive_myboard7 .owl-dots .owl-dot {
  display: inline-block;
}
.pm-myboard_slide_responsive_myboard7 .owl-dots .owl-dot span {
  display: block;
  width: 10px;
  height: 10px;
  margin: 0 4px;
  background: #ddd;
  border-radius: 30px;
  transition: opacity 200ms ease;
}
.pm-myboard_slide_responsive_myboard7 .owl-dots .owl-dot.active span,
.pm-myboard_slide_responsive_myboard7 .owl-dots .owl-dot:hover span {
  background: #999;
}

.pm-myboard_slide_responsive_myboard7 .item > a > div.bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: none;
  opacity: 0;
  transition: all.2s;
}
.pm-myboard_slide_responsive_myboard7 .item > a > div.bg > span {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  line-height: 80px;
  text-align: center;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  top: 50%;
  background: #ba7b3d;
  color: #fff;
  font-weight: 500;
}

@media screen and (min-width: 1100px) {
  .pm-myboard_slide_responsive_myboard7 .item > a:hover > div.bg {
    display: block;
    opacity: 1;
  }
}

.pm-myboard_slide_responsive_myboard10 {
  max-width: 1200px;
  margin: 0 auto;
}
.pm-myboard_slide_responsive_myboard10 a {
  display: block;
  border: none;
  position: relative;
}
.pm-myboard_slide_responsive_myboard10 .owl-item {
  z-index: 1;
}
.pm-myboard_slide_responsive_myboard10 .item {
  position: relative;
}
.pm-myboard_slide_responsive_myboard10 .item .figure {
  border: 1px solid #ddd;
}
.pm-myboard_slide_responsive_myboard10 .item p {
  font-size: 14px;
  padding-top: 10px;
  text-align: center;
}
.pm-myboard_slide_responsive_myboard10 .item p strong {
  display: block;
  font-weight: 600;
  font-size: 15px;
  padding-bottom: 5px;
}
.pm-myboard_slide_responsive_myboard10 .owl-nav {
  -webkit-tap-highlight-color: transparent;
}
.pm-myboard_slide_responsive_myboard10 .owl-nav [class*="owl-"] {
  position: absolute;
  top: 50%;
  z-index: 2;
  width: 40px;
  height: 40px;
  line-height: 40px;
  margin-top: -20px;
  font-size: 0;
  cursor: pointer;
  opacity: 0.7;
}
.pm-myboard_slide_responsive_myboard10 .owl-nav [class*="owl-"]:before {
  font-family: "icomoon_slider";
  font-size: 40px;
  font-weight: bold;
  color: #fff;
}
.pm-myboard_slide_responsive_myboard10 .owl-nav [class*="owl-"]:hover {
  opacity: 1;
}
.pm-myboard_slide_responsive_myboard10 .owl-nav .owl-prev {
  left: 5px;
}
.pm-myboard_slide_responsive_myboard10 .owl-nav .owl-next {
  right: 5px;
}
.pm-myboard_slide_responsive_myboard10 .owl-nav .owl-prev:before {
  content: "\e600";
}
.pm-myboard_slide_responsive_myboard10 .owl-nav .owl-next:before {
  content: "\e601";
}
.pm-myboard_slide_responsive_myboard10 .owl-nav .disabled {
  opacity: 0.5;
  cursor: default;
}

.pm-myboard_slide_responsive_myboard10 .owl-dots {
  position: absolute;
  left: 0;
  width: 100%;
  height: 30px;
  padding: 10px;
  font-size: 0;
  box-sizing: border-box;
  text-align: center;
}
.pm-myboard_slide_responsive_myboard10 .owl-dots .owl-dot {
  display: inline-block;
}
.pm-myboard_slide_responsive_myboard10 .owl-dots .owl-dot span {
  display: block;
  width: 10px;
  height: 10px;
  margin: 0 4px;
  background: #ddd;
  border-radius: 30px;
  transition: opacity 200ms ease;
}
.pm-myboard_slide_responsive_myboard10 .owl-dots .owl-dot.active span,
.pm-myboard_slide_responsive_myboard10 .owl-dots .owl-dot:hover span {
  background: #999;
}

.pm-myboard_slide_responsive_myboard10 .item > a > div.bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: none;
  opacity: 0;
  transition: all.2s;
}
.pm-myboard_slide_responsive_myboard10 .item > a > div.bg > span {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  line-height: 80px;
  text-align: center;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  top: 50%;
  background: #ba7b3d;
  color: #fff;
  font-weight: 500;
}

@media screen and (min-width: 1100px) {
  .pm-myboard_slide_responsive_myboard10 .item > a:hover > div.bg {
    display: block;
    opacity: 1;
  }
}

.pm-banner_slide_responsive_partner {
  max-width: 1199px;
  margin: 20px auto;
  padding: 0 10px;
  box-sizing: border-box;
}
.pm-banner_slide_responsive_partner a {
  text-align: center;
  display: block;
}
.pm-banner_slide_responsive_partner a img {
  /* 이미지 가운데 정렬을 위한 스타일 추가 */
  display: block;
  margin-left: auto;
  margin-right: auto;
  border: none;
  width: auto !important;
}
.pm-banner_slide_responsive_partner .owl-item {
  z-index: 1;
}
.pm-banner_slide_responsive_partner .item {
  position: relative;
  border: 1px solid #ddd;
  box-sizing: border-box;
}

.pm-banner_slide_responsive_partner .owl-nav {
  -webkit-tap-highlight-color: transparent;
}
.pm-banner_slide_responsive_partner .owl-nav [class*="owl-"] {
  position: absolute;
  top: 50%;
  z-index: 2;
  width: 40px;
  height: 40px;
  line-height: 40px;
  margin-top: -20px;
  font-size: 0;
  cursor: pointer;
  opacity: 0.7;
}
.pm-banner_slide_responsive_partner .owl-nav [class*="owl-"]:before {
  font-family: "icomoon_slider";
  font-size: 40px;
  font-weight: bold;
  color: #fff;
}
.pm-banner_slide_responsive_partner .owl-nav [class*="owl-"]:hover {
  opacity: 1;
}
.pm-banner_slide_responsive_partner .owl-nav .owl-prev {
  left: 5px;
}
.pm-banner_slide_responsive_partner .owl-nav .owl-next {
  right: 5px;
}
.pm-banner_slide_responsive_partner .owl-nav .owl-prev:before {
  content: "\e600";
}
.pm-banner_slide_responsive_partner .owl-nav .owl-next:before {
  content: "\e601";
}
.pm-banner_slide_responsive_partner .owl-nav .disabled {
  opacity: 0.5;
  cursor: default;
}

.pm-banner_slide_responsive_partner .owl-dots {
  position: absolute;
  left: 0;
  width: 100%;
  height: 30px;
  padding: 10px;
  font-size: 0;
  box-sizing: border-box;
  text-align: center;
}
.pm-banner_slide_responsive_partner .owl-dots .owl-dot {
  display: inline-block;
}
.pm-banner_slide_responsive_partner .owl-dots .owl-dot span {
  display: block;
  width: 10px;
  height: 10px;
  margin: 0 4px;
  background: #ddd;
  border-radius: 30px;
  transition: opacity 200ms ease;
}
.pm-banner_slide_responsive_partner .owl-dots .owl-dot.active span,
.pm-banner_slide_responsive_partner .owl-dots .owl-dot:hover span {
  background: #999;
}

.pm-login_b_login_b form {
  margin: 0;
}
.pm-login_b_login_b fieldset {
  margin: 0;
  border: none;
  padding: 0;
}
.pm-login_b_login_b fieldset legend {
  overflow: hidden;
  width: 0;
  height: 0;
  font-size: 0;
  line-height: 0;
  visibility: hidden;
  position: absolute;
}
.pm-login_b_login_b .from {
  display: table;
  width: 100%;
  margin: 0;
}
.pm-login_b_login_b .from dt {
  display: table-cell;
  padding-right: 10px;
  vertical-align: top;
}
.pm-login_b_login_b .from dt p {
  margin: 0;
}
.pm-login_b_login_b .from dt input {
  display: block;
  width: 100%;
  height: 35px;
  line-height: 35px;
  padding: 0 5px;
  font-size: 14px;
  color: #333;
  border: 1px solid #bbb;
  box-shadow: inset 0 2px 3px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  font-family: "Noto Sans", NanumGothic, "나눔고딕", "Open Sans", sans-serif;
}
.pm-login_b_login_b .from dt input[type="password"] {
  margin-top: 8px;
}
.pm-login_b_login_b .from dd {
  margin: 0;
  display: table-cell;
  width: 80px;
  padding: 0;
  vertical-align: top;
}
.pm-login_b_login_b .from dd button {
  width: 100%;
  height: 68px;
  border: none;
  margin: 0;
  font-size: 14px;
  color: #fff;
  font-weight: 600;
  background: #c9b61f;
  box-sizing: border-box;
  font-family: "Noto Sans", NanumGothic, "나눔고딕", "Open Sans", sans-serif;
}
.pm-login_b_login_b .checks {
  margin: 0px 0 0 0;
}
.pm-login_b_login_b .checks label {
  display: inline-block;
  font-size: 13px;
  color: #333;
  margin-right: 8px;
  font-family: "Noto Sans", NanumGothic, "나눔고딕", "Open Sans", sans-serif;
}
.pm-login_b_login_b .checks label > * {
  vertical-align: middle;
}
.pm-login_b_login_b .nav {
  overflow: hidden;
  padding: 10px 0 0 0;
  text-align: center;
}
.pm-login_b_login_b .nav a {
  display: block;
  font-size: 13px;
  color: #fff;
  font-family: "Noto Sans", NanumGothic, "나눔고딕", "Open Sans", sans-serif;
  width: 49.5%;
  float: left;
  padding: 9px 0;
  box-sizing: border-box;
  background: #c0c0c0;
}
.pm-login_b_login_b .nav a:first-child {
  margin-right: 1%;
}
.pm-login_b_login_b .msg {
  padding: 50px 0 20px 0;
  font-size: 16px;
  color: #333;
  text-align: center;
  font-family: "Noto Sans", NanumGothic, "나눔고딕", "Open Sans", sans-serif;
}
.pm-login_b_login_b .msg strong {
  color: #0467d1;
  font-weight: 500;
}

@media screen and (min-width: 768px) {
  .pm-login_b_login_b .checks label,
  .pm-login_b_login_b .nav a {
    font-size: 11px;
  }
  .pm-login_b_login_b .from dt input {
    font-size: 12px;
  }
}

@media screen and (min-width: 1100px) {
  .pm-login_b_login_b .checks label,
  .pm-login_b_login_b .nav a {
    font-size: 13px;
  }
  .pm-login_b_login_b .from dt input {
    font-size: 14px;
  }
}

.wrap_flex {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
}

.card {
  cursor: pointer;
  width: 100%;
  max-width: 450px;
  height: 400px;
  /* border: 1px solid #ccc; */
  padding: 20px;
  /* box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1); */
}

.card-borad {
  border: 1px solid #ccc;
  height: auto !important;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
}

.card-header h2 {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 4px;
}

.card-header p {
  font-size: 13px;
  color: #888;
  margin-bottom: 12px;
}
.card-body {
  display: flex;
  flex-direction: column;
  justify-content: center; /* 수직 가운데 정렬 */
  align-items: center; /* 수평 가운데 정렬 (flex 아이템 기준) */
  height: 100%; /* .card 내부의 사용 가능한 전체 높이를 채움 */
}
.card-body h3 {
  color: #c37848;
  font-size: 17px;
  text-align: center;
  margin-bottom: 15px;
}

.card-body .icon {
  display: block;
  margin: 0 auto 10px;
  width: 100px;
  height: 100px;
  border-radius: 50%;
}

.card-body .icon2 {
  display: block;
  margin: 0 auto 10px;
  width: 50px;
}

.card-body p {
  text-align: center;
  font-size: 15px;
}

.highlight {
  color: #d94d4d;
  font-weight: bold;
}
.login-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(
    255,
    255,
    255,
    0.7
  ); /* Semi-transparent white background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10; /* Ensure it's above other content within the login box */
  border-radius: inherit; /* Inherit border-radius from parent if any */
}
</style>
